import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Switch } from "../components/ui/switch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { toast } from "sonner";
import {
  Mail,
  Users,
  CheckCircle,
  Clock,
  LogOut,
  User,
  Plus,
  Settings,
  DollarSign,
  BarChart3,
  Globe,
  Eye,
  Check,
  X,
  Edit,
  Trash2,
  UserPlus,
  Copy,
  Calendar,
  UsersRound,
  LineChart,
  FileText,
  Ban,
  MoreVertical,
  Search,
  Archive,
  ChevronLeft,
  ChevronRight,
  Building2,
  Inbox,
  MessageSquare,
  Download,
  Bell,
  AlertTriangle,
  ShieldX,
  TrendingUp,
  TrendingDown,
  Link2,
  RefreshCw,
  ArrowLeft,
  Send,
  Shield,
  Loader2,
  ClipboardList,
  History,
  Activity,
  Lock
} from "lucide-react";
import AdminReports from "../components/AdminReports";
import AdminEmailTemplates from "../components/AdminEmailTemplates";
import AdminClients from "../components/AdminClients";
import { FraudDetailsDialog, FraudStatsSection, StatsGrid } from "../components/admin";

export default function AdminDashboard() {
  const { user, logout, token } = useAuth();
  const navigate = useNavigate();
  const [analytics, setAnalytics] = useState(null);
  const [users, setUsers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [domains, setDomains] = useState([]);
  const [groups, setGroups] = useState([]);
  const [settings, setSettings] = useState(null);
  const [teamManagers, setTeamManagers] = useState([]);
  const [contactSubmissions, setContactSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // New state for email delivery features
  const [adminNotifications, setAdminNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [suppressionList, setSuppressionList] = useState([]);
  const [emailDeliveryReport, setEmailDeliveryReport] = useState(null);
  const [emailHealthStats, setEmailHealthStats] = useState(null);
  const [webhookConfig, setWebhookConfig] = useState(null);
  const [showNotificationsPanel, setShowNotificationsPanel] = useState(false);
  const [showEmailPreview, setShowEmailPreview] = useState(false);

  // Support ticket state
  const [supportTickets, setSupportTickets] = useState([]);
  const [supportTicketSearch, setSupportTicketSearch] = useState("");
  const [supportTicketStatusFilter, setSupportTicketStatusFilter] = useState("all");
  const [supportTicketPage, setSupportTicketPage] = useState(1);
  const [supportTicketTotalPages, setSupportTicketTotalPages] = useState(1);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketDetail, setTicketDetail] = useState(null);
  const [ticketReplyMessage, setTicketReplyMessage] = useState("");
  const [ticketStats, setTicketStats] = useState(null);
  const [submittingReply, setSubmittingReply] = useState(false);

  // Audit logs state
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditLogsTotal, setAuditLogsTotal] = useState(0);
  const [auditLogsPage, setAuditLogsPage] = useState(1);
  const [auditLogsTotalPages, setAuditLogsTotalPages] = useState(1);
  const [auditLogsSearch, setAuditLogsSearch] = useState("");
  const [auditLogsActionFilter, setAuditLogsActionFilter] = useState("all");
  const [auditLogsDateFilter, setAuditLogsDateFilter] = useState("");
  const [auditLogsStats, setAuditLogsStats] = useState(null);
  const [auditActionTypes, setAuditActionTypes] = useState([]);
  const [loadingAuditLogs, setLoadingAuditLogs] = useState(false);
  const [activeTab, setActiveTab] = useState("users");

  // Fraud detection state
  const [fraudStats, setFraudStats] = useState(null);
  const [selectedUserFraud, setSelectedUserFraud] = useState(null);
  const [showFraudDialog, setShowFraudDialog] = useState(false);
  const [showFraudStats, setShowFraudStats] = useState(false);

  // Dialog states
  const [taskDialogOpen, setTaskDialogOpen] = useState(false);
  const [domainDialogOpen, setDomainDialogOpen] = useState(false);
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [groupDialogOpen, setGroupDialogOpen] = useState(false);
  const [addToGroupDialogOpen, setAddToGroupDialogOpen] = useState(false);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedUserForGroup, setSelectedUserForGroup] = useState("");
  
  // Send Emails Dialog state
  const [sendEmailsDialogOpen, setSendEmailsDialogOpen] = useState(false);
  const [selectedTaskForEmail, setSelectedTaskForEmail] = useState(null);
  const [sendEmailsForm, setSendEmailsForm] = useState({
    domain_id: "",
    group_ids: [],
    country: ""
  });
  const [sendingEmails, setSendingEmails] = useState(false);

  // Form states
  const [taskForm, setTaskForm] = useState({
    title: "",
    description: "",
    task_type: "click_url",
    completion_method: "auto",
    points_reward: 10,
    instructions: "",
    target_url: "",
    client_id: "",
    email_domain_id: "",
    email_subject: "",
    email_body: "",
    availability_hours: 24,
    completion_minutes: 10,
    scheduled_at: "",
    schedule_slots: [],  // Advanced scheduling: [{date: "2026-03-10", time: "09:00"}]
    group_ids: [],
    max_completions: "",
    is_active: true
  });
  const [editingTask, setEditingTask] = useState(null);
  const [clients, setClients] = useState([]);

  const [domainForm, setDomainForm] = useState({
    domain: "",
    sparkpost_api_key: "",
    from_email: "",
    from_name: "",
    daily_limit_per_user: 5,
    is_active: true,
    tracking_mode: "internal",
    custom_tracking_domain: ""
  });

  const [settingsForm, setSettingsForm] = useState({
    points_per_usd: 100,
    min_withdrawal: 10,
    withdrawal_fee_percent: 2,
    postmark_server_token: "",
    postmark_from_email: ""
  });

  const [groupForm, setGroupForm] = useState({
    name: "",
    description: ""
  });

  // Password Change State
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [changingPassword, setChangingPassword] = useState(false);

  // Pagination and Search States
  const [taskSearch, setTaskSearch] = useState("");
  const [taskPage, setTaskPage] = useState(1);
  const [taskTotalPages, setTaskTotalPages] = useState(1);
  const [showArchivedTasks, setShowArchivedTasks] = useState(false);
  const [taskStats, setTaskStats] = useState(null);
  const [taskClientFilter, setTaskClientFilter] = useState("all");
  
  const [userSearch, setUserSearch] = useState("");
  const [userPage, setUserPage] = useState(1);
  const [userTotalPages, setUserTotalPages] = useState(1);
  const [userStatusFilter, setUserStatusFilter] = useState("all");
  const [userFraudFilter, setUserFraudFilter] = useState("all");  // New: fraud filter
  
  const [submissionPage, setSubmissionPage] = useState(1);
  const [submissionTotalPages, setSubmissionTotalPages] = useState(1);
  const [showArchivedSubmissions, setShowArchivedSubmissions] = useState(false);
  const [submissionStatusFilter, setSubmissionStatusFilter] = useState("all");
  const [submissionSearch, setSubmissionSearch] = useState("");
  const [submissionDateFilter, setSubmissionDateFilter] = useState("");
  
  // Payment Approvals
  const [pendingPaymentApprovals, setPendingPaymentApprovals] = useState([]);
  const [submissionStats, setSubmissionStats] = useState(null);

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    fetchData();
  }, []);

  // Separate effect for task search/pagination
  useEffect(() => {
    fetchTasks();
  }, [taskSearch, taskPage, showArchivedTasks, taskClientFilter]);

  // Separate effect for user search/pagination
  useEffect(() => {
    fetchUsers();
  }, [userSearch, userPage, userStatusFilter, userFraudFilter]);

  // Separate effect for submission pagination
  useEffect(() => {
    fetchSubmissions();
  }, [submissionPage, showArchivedSubmissions, submissionStatusFilter, submissionSearch, submissionDateFilter]);

  // Separate effect for support tickets pagination
  useEffect(() => {
    fetchSupportTickets();
  }, [supportTicketSearch, supportTicketStatusFilter, supportTicketPage]);

  // Separate effect for audit logs pagination
  useEffect(() => {
    if (activeTab === "audit") {
      fetchAuditLogs();
    }
  }, [auditLogsPage, auditLogsSearch, auditLogsActionFilter, auditLogsDateFilter, activeTab]);

  const fetchTasks = async () => {
    try {
      const params = new URLSearchParams();
      if (taskSearch) params.append("search", taskSearch);
      if (taskClientFilter && taskClientFilter !== "all") params.append("client_id", taskClientFilter);
      params.append("page", taskPage);
      params.append("page_size", 20);
      params.append("is_archived", showArchivedTasks);
      
      const [tasksRes, statsRes] = await Promise.all([
        axios.get(`${API}/v2/tasks?${params.toString()}`, { headers }),
        axios.get(`${API}/v2/tasks/stats`, { headers })
      ]);
      
      setTasks(tasksRes.data.items || tasksRes.data);
      setTaskTotalPages(tasksRes.data.total_pages || 1);
      setTaskStats(statsRes.data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const params = new URLSearchParams();
      if (userSearch) params.append("search", userSearch);
      if (userStatusFilter && userStatusFilter !== "all") params.append("status", userStatusFilter);
      if (userFraudFilter && userFraudFilter !== "all") params.append("fraud_filter", userFraudFilter);
      params.append("page", userPage);
      params.append("page_size", 20);
      
      const usersRes = await axios.get(`${API}/v2/users?${params.toString()}`, { headers });
      setUsers(usersRes.data.items || usersRes.data);
      setUserTotalPages(usersRes.data.total_pages || 1);
      setTeamManagers((usersRes.data.items || usersRes.data).filter(u => u.role === "team_manager"));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchSubmissions = async () => {
    try {
      const params = new URLSearchParams();
      params.append("page", submissionPage);
      params.append("page_size", 20);
      params.append("is_archived", showArchivedSubmissions);
      if (submissionStatusFilter && submissionStatusFilter !== "all") {
        params.append("status", submissionStatusFilter);
      }
      if (submissionSearch) {
        params.append("search", submissionSearch);
      }
      if (submissionDateFilter) {
        params.append("date", submissionDateFilter);
      }
      
      const [submissionsRes, statsRes] = await Promise.all([
        axios.get(`${API}/v2/submissions?${params.toString()}`, { headers }),
        axios.get(`${API}/v2/submissions/stats`, { headers })
      ]);
      
      setSubmissions(submissionsRes.data.items || submissionsRes.data);
      setSubmissionTotalPages(submissionsRes.data.total_pages || 1);
      setSubmissionStats(statsRes.data);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  };

  const fetchSupportTickets = async () => {
    try {
      const params = new URLSearchParams();
      if (supportTicketSearch) params.append("search", supportTicketSearch);
      if (supportTicketStatusFilter && supportTicketStatusFilter !== "all") {
        params.append("status", supportTicketStatusFilter);
      }
      params.append("page", supportTicketPage);
      params.append("limit", 20);
      
      const [ticketsRes, statsRes] = await Promise.all([
        axios.get(`${API}/v2/tickets?${params.toString()}`, { headers }),
        axios.get(`${API}/v2/tickets/stats/summary`, { headers }).catch(() => ({ data: null }))
      ]);
      
      setSupportTickets(ticketsRes.data.items || []);
      setSupportTicketTotalPages(ticketsRes.data.total_pages || 1);
      if (statsRes.data) setTicketStats(statsRes.data);
    } catch (error) {
      console.error("Error fetching support tickets:", error);
    }
  };

  const handleViewTicket = async (ticketId) => {
    try {
      const response = await axios.get(`${API}/v2/tickets/${ticketId}`, { headers });
      setTicketDetail(response.data);
      setSelectedTicket(ticketId);
    } catch (error) {
      toast.error("Failed to load ticket");
    }
  };

  const handleSendTicketReply = async () => {
    if (!ticketReplyMessage.trim() || !selectedTicket) return;
    
    setSubmittingReply(true);
    try {
      await axios.post(`${API}/v2/tickets/${selectedTicket}/reply`, { message: ticketReplyMessage }, { headers });
      toast.success("Reply sent");
      setTicketReplyMessage("");
      handleViewTicket(selectedTicket);
      fetchSupportTickets();
    } catch (error) {
      toast.error("Failed to send reply");
    } finally {
      setSubmittingReply(false);
    }
  };

  const handleUpdateTicketStatus = async (ticketId, status) => {
    try {
      await axios.patch(`${API}/v2/tickets/${ticketId}`, { status }, { headers });
      toast.success(`Ticket marked as ${status}`);
      if (selectedTicket === ticketId) {
        handleViewTicket(ticketId);
      }
      fetchSupportTickets();
    } catch (error) {
      toast.error("Failed to update ticket status");
    }
  };

  // Audit Logs Functions
  const fetchAuditLogs = async () => {
    setLoadingAuditLogs(true);
    try {
      const params = new URLSearchParams();
      params.append("page", auditLogsPage);
      params.append("page_size", 20);
      if (auditLogsSearch) params.append("search", auditLogsSearch);
      if (auditLogsActionFilter && auditLogsActionFilter !== "all") params.append("action", auditLogsActionFilter);
      if (auditLogsDateFilter) {
        params.append("start_date", auditLogsDateFilter);
        params.append("end_date", auditLogsDateFilter);
      }
      
      const [logsRes, statsRes, actionsRes] = await Promise.all([
        axios.get(`${API}/v2/audit-logs?${params.toString()}`, { headers }),
        axios.get(`${API}/v2/audit-logs/stats?days=30`, { headers }).catch(() => ({ data: null })),
        auditActionTypes.length === 0 ? axios.get(`${API}/v2/audit-logs/actions`, { headers }) : Promise.resolve({ data: { actions: auditActionTypes } })
      ]);
      
      setAuditLogs(logsRes.data.items || []);
      setAuditLogsTotal(logsRes.data.total || 0);
      setAuditLogsTotalPages(logsRes.data.total_pages || 1);
      if (statsRes.data) setAuditLogsStats(statsRes.data);
      if (actionsRes.data?.actions) setAuditActionTypes(actionsRes.data.actions);
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      toast.error("Failed to load audit logs");
    } finally {
      setLoadingAuditLogs(false);
    }
  };

  const handleExportAuditLogs = async () => {
    try {
      const params = new URLSearchParams();
      if (auditLogsActionFilter && auditLogsActionFilter !== "all") params.append("action", auditLogsActionFilter);
      if (auditLogsDateFilter) {
        params.append("start_date", auditLogsDateFilter);
        params.append("end_date", auditLogsDateFilter);
      }
      
      window.location.href = `${API}/v2/audit-logs/export?${params.toString()}`;
      toast.success("Downloading audit logs...");
    } catch (error) {
      toast.error("Failed to export audit logs");
    }
  };

  const getActionBadgeColor = (action) => {
    if (action?.includes("login")) return "bg-blue-100 text-blue-800";
    if (action?.includes("approve") || action?.includes("activate")) return "bg-green-100 text-green-800";
    if (action?.includes("reject") || action?.includes("suspend") || action?.includes("delete")) return "bg-red-100 text-red-800";
    if (action?.includes("create") || action?.includes("register")) return "bg-purple-100 text-purple-800";
    if (action?.includes("update") || action?.includes("change")) return "bg-yellow-100 text-yellow-800";
    return "bg-gray-100 text-gray-800";
  };

  const formatActionLabel = (action) => {
    return action?.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()) || "Unknown";
  };

  // Fraud detection functions
  const handleViewFraudData = async (userId) => {
    try {
      const response = await axios.get(`${API}/v2/fraud/user/${userId}`, { headers });
      setSelectedUserFraud(response.data);
      setShowFraudDialog(true);
    } catch (error) {
      toast.error("Failed to load fraud data");
    }
  };

  const handleRecheckFraud = async (userId) => {
    try {
      const response = await axios.post(`${API}/v2/fraud/recheck/${userId}`, {}, { headers });
      toast.success(`Fraud recheck complete: Score ${response.data.result.fraud_score}, Risk: ${response.data.result.risk_level}`);
      setSelectedUserFraud(null);
      setShowFraudDialog(false);
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to recheck fraud");
    }
  };

  const handleClearFraudFlag = async (userId) => {
    try {
      await axios.patch(`${API}/v2/fraud/clear-flag/${userId}`, {}, { headers });
      toast.success("Fraud flag cleared");
      setSelectedUserFraud(null);
      setShowFraudDialog(false);
      fetchData();
    } catch (error) {
      toast.error("Failed to clear fraud flag");
    }
  };

  const getRiskLevelBadge = (riskLevel) => {
    switch (riskLevel) {
      case "low": return "bg-green-100 text-green-700";
      case "medium": return "bg-yellow-100 text-yellow-700";
      case "high": return "bg-orange-100 text-orange-700";
      case "critical": return "bg-red-100 text-red-700";
      default: return "bg-gray-100 text-gray-700";
    }
  };

  const fetchData = async () => {
    try {
      const [
        analyticsRes,
        usersRes,
        tasksRes,
        submissionsRes,
        withdrawalsRes,
        domainsRes,
        settingsRes,
        groupsRes,
        taskStatsRes,
        submissionStatsRes,
        pendingPaymentRes,
        clientsRes
      ] = await Promise.all([
        axios.get(`${API}/v2/analytics/overview`, { headers }),
        axios.get(`${API}/v2/users?page=1&page_size=20`, { headers }),
        axios.get(`${API}/v2/tasks?page=1&page_size=20&is_archived=false`, { headers }),
        axios.get(`${API}/v2/submissions?page=1&page_size=20&is_archived=false`, { headers }),
        axios.get(`${API}/v2/withdrawals`, { headers }),
        axios.get(`${API}/v2/email-domains`, { headers }),
        axios.get(`${API}/v2/settings`, { headers }),
        axios.get(`${API}/v2/groups`, { headers }),
        axios.get(`${API}/v2/tasks/stats`, { headers }),
        axios.get(`${API}/v2/submissions/stats`, { headers }),
        axios.get(`${API}/v2/users/admin/pending-payment-approvals`, { headers }),
        axios.get(`${API}/v2/clients`, { headers })
      ]);

      // Fetch contact submissions separately (non-critical)
      try {
        const contactRes = await axios.get(`${API}/v2/contact`, { headers });
        setContactSubmissions(contactRes.data.items || []);
      } catch (e) {
        console.log("Contact submissions not available");
      }
      
      // Fetch email delivery features (non-critical)
      try {
        const [notifRes, suppressionRes, deliveryRes, webhookRes, healthRes] = await Promise.all([
          axios.get(`${API}/v2/admin/notifications`, { headers }),
          axios.get(`${API}/v2/suppression-list?limit=100`, { headers }),
          axios.get(`${API}/v2/reports/email-delivery?days=7`, { headers }),
          axios.get(`${API}/v2/settings/webhook-config`, { headers }),
          axios.get(`${API}/email-health/stats?days=30`, { headers })
        ]);
        setAdminNotifications(notifRes.data.items || []);
        setUnreadNotifications(notifRes.data.unread_count || 0);
        setSuppressionList(suppressionRes.data.items || []);
        setEmailDeliveryReport(deliveryRes.data);
        setWebhookConfig(webhookRes.data);
        setEmailHealthStats(healthRes.data);
      } catch (e) {
        console.log("Email delivery features not available:", e);
      }

      // Fetch fraud stats (non-critical)
      try {
        const fraudRes = await axios.get(`${API}/v2/fraud/stats`, { headers });
        setFraudStats(fraudRes.data);
      } catch (e) {
        console.log("Fraud stats not available:", e);
      }

      setAnalytics(analyticsRes.data);
      setUsers(usersRes.data.items || usersRes.data);
      setUserTotalPages(usersRes.data.total_pages || 1);
      setTasks(tasksRes.data.items || tasksRes.data);
      setTaskTotalPages(tasksRes.data.total_pages || 1);
      setTaskStats(taskStatsRes.data);
      setSubmissions(submissionsRes.data.items || submissionsRes.data);
      setSubmissionTotalPages(submissionsRes.data.total_pages || 1);
      setSubmissionStats(submissionStatsRes.data);
      // Handle paginated withdrawals response
      setWithdrawals(withdrawalsRes.data.items || withdrawalsRes.data || []);
      setDomains(domainsRes.data);
      setGroups(groupsRes.data);
      setSettings(settingsRes.data);
      // Handle paginated clients response
      setClients(clientsRes.data.items || clientsRes.data || []);
      setSettingsForm({
        points_per_usd: settingsRes.data.points_per_usd,
        min_withdrawal: settingsRes.data.min_withdrawal,
        withdrawal_fee_percent: settingsRes.data.withdrawal_fee_percent,
        postmark_server_token: settingsRes.data.postmark_server_token || "",
        postmark_from_email: settingsRes.data.postmark_from_email || ""
      });
      setTeamManagers((usersRes.data.items || usersRes.data).filter(u => u.role === "team_manager"));
      setPendingPaymentApprovals(pendingPaymentRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveTask = async (taskId) => {
    try {
      await axios.post(`${API}/v2/tasks/${taskId}/archive`, {}, { headers });
      toast.success("Task archived");
      fetchTasks();
    } catch (error) {
      toast.error("Failed to archive task");
    }
  };

  const handleUnarchiveTask = async (taskId) => {
    try {
      await axios.post(`${API}/v2/tasks/${taskId}/unarchive`, {}, { headers });
      toast.success("Task unarchived");
      fetchTasks();
    } catch (error) {
      toast.error("Failed to unarchive task");
    }
  };

  const handleMarkNotificationRead = async (notificationId) => {
    try {
      await axios.patch(`${API}/v2/admin/notifications/${notificationId}/read`, {}, { headers });
      setAdminNotifications(prev => prev.map(n => 
        n.notification_id === notificationId ? { ...n, is_read: true } : n
      ));
      setUnreadNotifications(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Failed to mark notification read");
    }
  };

  const handleMarkAllNotificationsRead = async () => {
    try {
      await axios.post(`${API}/v2/admin/notifications/mark-all-read`, {}, { headers });
      setAdminNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
      setUnreadNotifications(0);
      toast.success("All notifications marked as read");
    } catch (error) {
      toast.error("Failed to mark all as read");
    }
  };

  const handleRemoveFromSuppression = async (suppressionId) => {
    try {
      await axios.delete(`${API}/v2/suppression-list/${suppressionId}`, { headers });
      setSuppressionList(prev => prev.filter(s => s.suppression_id !== suppressionId));
      toast.success("Removed from suppression list");
    } catch (error) {
      toast.error("Failed to remove from suppression list");
    }
  };

  const handleAddToSuppression = async (email, reason = "manual") => {
    try {
      await axios.post(`${API}/v2/suppression-list`, { email, reason }, { headers });
      fetchData();
      toast.success(`Added ${email} to suppression list`);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add to suppression list");
    }
  };

  const handleAutoArchiveOldTasks = async () => {
    try {
      const response = await axios.post(`${API}/v2/tasks/archive-old?days=60`, {}, { headers });
      toast.success(response.data.message);
      fetchTasks();
    } catch (error) {
      toast.error("Failed to archive old tasks");
    }
  };

  const handleAutoArchiveOldSubmissions = async () => {
    try {
      const response = await axios.post(`${API}/v2/submissions/archive-old?days=60`, {}, { headers });
      toast.success(response.data.message);
      fetchSubmissions();
    } catch (error) {
      toast.error("Failed to archive old submissions");
    }
  };

  const handlePaymentApproval = async (userId, action) => {
    try {
      await axios.post(`${API}/v2/users/admin/approve-payment/${userId}`, { action }, { headers });
      toast.success(`Payment details ${action === "approve" ? "approved" : "rejected"}`);
      // Refresh data
      const pendingPaymentRes = await axios.get(`${API}/v2/users/admin/pending-payment-approvals`, { headers });
      setPendingPaymentApprovals(pendingPaymentRes.data);
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || `Failed to ${action} payment details`);
    }
  };

  const handleCreateTask = async () => {
    try {
      // Clean up empty optional fields
      const taskData = { ...taskForm };
      if (!taskData.email_domain_id) delete taskData.email_domain_id;
      if (!taskData.email_subject) delete taskData.email_subject;
      if (!taskData.email_body) delete taskData.email_body;
      if (!taskData.scheduled_at) delete taskData.scheduled_at;
      if (!taskData.schedule_slots || taskData.schedule_slots.length === 0) delete taskData.schedule_slots;
      if (!taskData.group_ids || taskData.group_ids.length === 0) delete taskData.group_ids;
      if (!taskData.client_id) delete taskData.client_id;
      // Convert max_completions to null if empty/0
      if (!taskData.max_completions) {
        taskData.max_completions = null;
      }
      
      if (editingTask) {
        // Update existing task
        await axios.patch(`${API}/v2/tasks/${editingTask.task_id}`, taskData, { headers });
        toast.success("Task updated successfully");
      } else {
        // Create new task
        await axios.post(`${API}/v2/tasks`, taskData, { headers });
        toast.success("Task created successfully");
      }
      
      setTaskDialogOpen(false);
      setEditingTask(null);
      setTaskForm({
        title: "",
        description: "",
        task_type: "click_url",
        completion_method: "auto",
        points_reward: 10,
        instructions: "",
        target_url: "",
        client_id: "",
        email_domain_id: "",
        email_subject: "",
        email_body: "",
        availability_hours: 24,
        completion_minutes: 10,
        scheduled_at: "",
        schedule_slots: [],
        group_ids: [],
        max_completions: "",
        is_active: true
      });
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || `Failed to ${editingTask ? 'update' : 'create'} task`);
    }
  };

  const handleEditTask = (task) => {
    setEditingTask(task);
    setTaskForm({
      title: task.title || "",
      description: task.description || "",
      task_type: task.task_type || "click_url",
      completion_method: task.completion_method || "auto",
      points_reward: task.points_reward || 10,
      instructions: task.instructions || "",
      target_url: task.target_url || "",
      client_id: task.client_id || "",
      email_domain_id: task.email_domain_id || "",
      email_subject: task.email_subject || "",
      email_body: task.email_body || "",
      availability_hours: task.availability_hours || 24,
      completion_minutes: task.completion_minutes || 10,
      scheduled_at: task.scheduled_at || "",
      schedule_slots: task.schedule_slots || [],
      group_ids: task.group_ids || [],
      max_completions: task.max_completions || "",
      is_active: task.is_active !== false
    });
    setTaskDialogOpen(true);
  };

  const handleCloneTask = async (taskId) => {
    // Find the task to clone
    const taskToClone = tasks.find(t => t.task_id === taskId);
    if (!taskToClone) {
      toast.error("Task not found");
      return;
    }
    
    // Open edit dialog with cloned task data (without publishing)
    setEditingTask(null); // Not editing, creating new
    setTaskForm({
      title: `${taskToClone.title} (Copy)`,
      description: taskToClone.description || "",
      task_type: taskToClone.task_type || "click_url",
      completion_method: taskToClone.completion_method || "auto",
      points_reward: taskToClone.points_reward || 10,
      instructions: taskToClone.instructions || "",
      target_url: taskToClone.target_url || "",
      client_id: taskToClone.client_id || "",
      email_domain_id: taskToClone.email_domain_id || "",
      email_subject: taskToClone.email_subject || "",
      email_body: taskToClone.email_body || "",
      availability_hours: taskToClone.availability_hours || 24,
      completion_minutes: taskToClone.completion_minutes || 10,
      scheduled_at: "",
      schedule_slots: [],
      group_ids: taskToClone.group_ids || [],
      max_completions: taskToClone.max_completions || "",
      is_active: false // Start as inactive so admin can review before publishing
    });
    setTaskDialogOpen(true);
    toast.info("Review the cloned task and click 'Create Task' to publish");
  };

  const handleCreateGroup = async () => {
    try {
      await axios.post(`${API}/v2/groups`, groupForm, { headers });
      toast.success("Group created successfully");
      setGroupDialogOpen(false);
      setGroupForm({ name: "", description: "" });
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to create group");
    }
  };

  const handleDeleteGroup = async (groupId) => {
    if (!window.confirm("Are you sure you want to delete this group?")) return;
    try {
      await axios.delete(`${API}/v2/groups/${groupId}`, { headers });
      toast.success("Group deleted");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete group");
    }
  };

  const handleSendTaskEmails = async () => {
    if (!selectedTaskForEmail || !sendEmailsForm.domain_id) {
      toast.error("Please select a domain");
      return;
    }
    
    setSendingEmails(true);
    try {
      const payload = {
        domain_id: sendEmailsForm.domain_id,
        group_ids: sendEmailsForm.group_ids.length > 0 ? sendEmailsForm.group_ids : undefined,
        country: sendEmailsForm.country || undefined
      };
      
      const response = await axios.post(
        `${API}/v2/tasks/${selectedTaskForEmail.task_id}/send-emails`,
        payload,
        { headers }
      );
      
      toast.success(
        `Emails sent! ${response.data.emails_sent} delivered, ${response.data.emails_failed} failed`
      );
      setSendEmailsDialogOpen(false);
      setSendEmailsForm({ domain_id: "", group_ids: [], country: "" });
      setSelectedTaskForEmail(null);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send emails");
    } finally {
      setSendingEmails(false);
    }
  };

  const handleAddUserToGroup = async () => {
    if (!selectedGroup || !selectedUserForGroup) return;
    try {
      await axios.post(`${API}/v2/groups/${selectedGroup}/members`, 
        { user_id: selectedUserForGroup }, 
        { headers }
      );
      toast.success("User added to group");
      setAddToGroupDialogOpen(false);
      setSelectedGroup("");
      setSelectedUserForGroup("");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add user to group");
    }
  };

  const handleRemoveUserFromGroup = async (groupId, userId) => {
    try {
      await axios.delete(`${API}/v2/groups/${groupId}/members/${userId}`, { headers });
      toast.success("User removed from group");
      fetchData();
    } catch (error) {
      toast.error("Failed to remove user from group");
    }
  };

  const handleCreateDomain = async () => {
    try {
      await axios.post(`${API}/v2/email-domains`, domainForm, { headers });
      toast.success("Domain added successfully");
      setDomainDialogOpen(false);
      setDomainForm({
        domain: "",
        sparkpost_api_key: "",
        from_email: "",
        from_name: "",
        daily_limit_per_user: 5,
        is_active: true,
        tracking_mode: "internal",
        custom_tracking_domain: ""
      });
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add domain");
    }
  };

  const handleImpersonate = async (userId) => {
    try {
      const response = await axios.post(`${API}/v2/auth/impersonate/${userId}`, {}, { headers });
      toast.success(response.data.message);
      
      // Store the impersonation token
      localStorage.setItem("token", response.data.token);
      
      // Navigate to the appropriate dashboard based on user role
      const targetUser = response.data.user;
      if (targetUser.role === "worker") {
        window.location.href = "/dashboard";
      } else if (targetUser.role === "team_manager") {
        window.location.href = "/team-manager";
      } else {
        window.location.href = "/admin";
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to impersonate user");
    }
  };

  const handleAssignGroupToManager = async (groupId, managerId) => {
    try {
      await axios.patch(`${API}/v2/groups/${groupId}`, 
        { team_manager_id: managerId || null }, 
        { headers }
      );
      toast.success("Group updated");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to assign group");
    }
  };

  const handleUpdateSettings = async () => {
    try {
      await axios.patch(`${API}/v2/settings`, settingsForm, { headers });
      toast.success("Settings updated");
      setSettingsDialogOpen(false);
      fetchData();
    } catch (error) {
      toast.error("Failed to update settings");
    }
  };

  const handleChangePassword = async () => {
    // Validation
    if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
      toast.error("Please fill in all password fields");
      return;
    }
    
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      toast.error("New passwords do not match");
      return;
    }
    
    if (passwordForm.newPassword.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    
    if (!/[A-Z]/.test(passwordForm.newPassword)) {
      toast.error("Password must contain at least one uppercase letter");
      return;
    }
    
    if (!/[a-z]/.test(passwordForm.newPassword)) {
      toast.error("Password must contain at least one lowercase letter");
      return;
    }
    
    if (!/[0-9]/.test(passwordForm.newPassword)) {
      toast.error("Password must contain at least one number");
      return;
    }
    
    setChangingPassword(true);
    try {
      await axios.post(`${API}/v2/auth/change-password`, {
        current_password: passwordForm.currentPassword,
        new_password: passwordForm.newPassword
      }, { headers });
      toast.success("Password changed successfully");
      setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to change password");
    } finally {
      setChangingPassword(false);
    }
  };

  const handleUpdateContactStatus = async (contactId, status) => {
    try {
      await axios.patch(`${API}/v2/contact/${contactId}?status=${status}`, {}, { headers });
      toast.success("Contact status updated");
      // Refresh contact submissions
      const contactRes = await axios.get(`${API}/v2/contact`, { headers });
      setContactSubmissions(contactRes.data.items || []);
    } catch (error) {
      toast.error("Failed to update contact status");
    }
  };

  const handleUpdateUserStatus = async (userId, status) => {
    try {
      await axios.patch(`${API}/v2/users/${userId}/status`, { status }, { headers });
      toast.success(`User ${status}`);
      fetchData();
    } catch (error) {
      toast.error("Failed to update user status");
    }
  };

  const handleExport = async (type, filters = {}) => {
    try {
      const params = new URLSearchParams(filters).toString();
      const url = `${API}/v2/export/${type}${params ? `?${params}` : ''}`;
      
      // Fetch the CSV data
      const response = await axios.get(url, { 
        headers,
        responseType: 'blob'
      });
      
      // Create download link
      const blob = new Blob([response.data], { type: 'text/csv' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${type}_export_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} exported successfully`);
    } catch (error) {
      toast.error(`Failed to export ${type}`);
    }
  };

  const handleAssignGigster = async () => {
    if (!selectedWorker || !selectedManager) return;
    try {
      await axios.post(`${API}/v2/users/assign-worker`, {
        worker_id: selectedWorker,
        team_manager_id: selectedManager
      }, { headers });
      toast.success("Gigster assigned to team manager");
      setAssignDialogOpen(false);
      setSelectedWorker(null);
      setSelectedManager("");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to assign gigster");
    }
  };

  const handleReviewSubmission = async (submissionId, status) => {
    try {
      await axios.patch(`${API}/v2/submissions/${submissionId}/review`, { status }, { headers });
      toast.success(`Submission ${status}`);
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to review submission");
    }
  };

  const handleProcessWithdrawal = async (withdrawalId, status) => {
    try {
      await axios.patch(`${API}/v2/withdrawals/${withdrawalId}/process`, { status }, { headers });
      toast.success(`Withdrawal ${status}`);
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to process withdrawal");
    }
  };

  const handleSendPayPalPayout = async (withdrawalId) => {
    if (!window.confirm("Send PayPal payout to the user? This will transfer real money.")) return;
    try {
      const response = await axios.post(`${API}/v2/withdrawals/${withdrawalId}/payout`, {}, { headers });
      toast.success(response.data.message || "PayPal payout sent successfully!");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send PayPal payout");
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!window.confirm("Are you sure you want to delete this task?")) return;
    try {
      await axios.delete(`${API}/v2/tasks/${taskId}`, { headers });
      toast.success("Task deleted");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete task");
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const pendingUsers = users.filter(u => u.status === "pending");
  const pendingWithdrawals = withdrawals.filter(w => w.status === "pending");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-dashboard">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src="/images/gigseasy-logo.svg" 
                alt="GigsEasy Logo" 
                className="h-10"
              />
              <div>
                <p className="text-sm text-slate-500">Admin Dashboard</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Dialog open={settingsDialogOpen} onOpenChange={setSettingsDialogOpen}>
                <DialogTrigger asChild>
                  <Button variant="ghost" size="icon" data-testid="settings-btn">
                    <Settings className="w-5 h-5" />
                  </Button>
                </DialogTrigger>
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>Platform Settings</DialogTitle>
                    <DialogDescription>Configure points, withdrawal, and email settings</DialogDescription>
                  </DialogHeader>
                  <div className="space-y-4 pt-4 max-h-[60vh] overflow-y-auto">
                    <div>
                      <Label>Points per USD</Label>
                      <Input
                        type="number"
                        value={settingsForm.points_per_usd}
                        onChange={(e) => setSettingsForm({ ...settingsForm, points_per_usd: parseFloat(e.target.value) })}
                        data-testid="points-per-usd-input"
                      />
                      <p className="text-sm text-slate-500 mt-1">e.g., 100 means 100 points = $1</p>
                    </div>
                    <div>
                      <Label>Minimum Withdrawal ($)</Label>
                      <Input
                        type="number"
                        value={settingsForm.min_withdrawal}
                        onChange={(e) => setSettingsForm({ ...settingsForm, min_withdrawal: parseFloat(e.target.value) })}
                        data-testid="min-withdrawal-input"
                      />
                    </div>
                    <div>
                      <Label>Withdrawal Fee (%)</Label>
                      <Input
                        type="number"
                        value={settingsForm.withdrawal_fee_percent}
                        onChange={(e) => setSettingsForm({ ...settingsForm, withdrawal_fee_percent: parseFloat(e.target.value) })}
                        data-testid="withdrawal-fee-input"
                      />
                    </div>
                    
                    <div className="border-t border-slate-200 pt-4 mt-4">
                      <h4 className="font-medium text-slate-900 mb-3 flex items-center gap-2">
                        <Mail className="w-4 h-4" />
                        Postmark Email Configuration
                      </h4>
                      <div className="space-y-3">
                        <div>
                          <Label>Postmark Server Token</Label>
                          <Input
                            type="password"
                            value={settingsForm.postmark_server_token || ""}
                            onChange={(e) => setSettingsForm({ ...settingsForm, postmark_server_token: e.target.value })}
                            placeholder="Enter Postmark server token"
                            data-testid="postmark-token-input"
                          />
                          <p className="text-xs text-slate-500 mt-1">
                            Get your token from <a href="https://account.postmarkapp.com/servers" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Postmark Dashboard</a>
                          </p>
                        </div>
                        <div>
                          <Label>From Email Address</Label>
                          <Input
                            type="email"
                            value={settingsForm.postmark_from_email || ""}
                            onChange={(e) => setSettingsForm({ ...settingsForm, postmark_from_email: e.target.value })}
                            placeholder="noreply@yourdomain.com"
                            data-testid="postmark-from-email-input"
                          />
                          <p className="text-xs text-slate-500 mt-1">Must be a verified sender in Postmark</p>
                        </div>
                        <Button 
                          variant="outline" 
                          size="sm" 
                          onClick={async () => {
                            try {
                              await axios.post(`${API}/v2/settings/test-email`, {}, { headers });
                              toast.success("Test email sent to your admin email");
                            } catch (error) {
                              toast.error(error.response?.data?.detail || "Failed to send test email");
                            }
                          }}
                          data-testid="test-email-btn"
                        >
                          Send Test Email
                        </Button>
                      </div>
                    </div>
                    
                    <Button onClick={handleUpdateSettings} className="w-full" data-testid="save-settings-btn">
                      Save Settings
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>
              
              {/* Notifications Bell */}
              <div className="relative">
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => setShowNotificationsPanel(!showNotificationsPanel)}
                  data-testid="notifications-btn"
                >
                  <Bell className="w-5 h-5" />
                  {unreadNotifications > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                      {unreadNotifications > 9 ? "9+" : unreadNotifications}
                    </span>
                  )}
                </Button>
                
                {/* Notifications Panel */}
                {showNotificationsPanel && (
                  <div className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg border border-slate-200 z-50">
                    <div className="p-4 border-b border-slate-100 flex items-center justify-between">
                      <h3 className="font-semibold">Notifications</h3>
                      {unreadNotifications > 0 && (
                        <Button variant="ghost" size="sm" onClick={handleMarkAllNotificationsRead}>
                          Mark all read
                        </Button>
                      )}
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                      {adminNotifications.length === 0 ? (
                        <div className="p-8 text-center text-slate-500">
                          <Bell className="w-8 h-8 mx-auto mb-2 text-slate-300" />
                          <p>No notifications</p>
                        </div>
                      ) : (
                        adminNotifications.slice(0, 10).map(notif => (
                          <div 
                            key={notif.notification_id}
                            className={`p-4 border-b border-slate-50 hover:bg-slate-50 cursor-pointer ${!notif.is_read ? 'bg-blue-50' : ''}`}
                            onClick={() => handleMarkNotificationRead(notif.notification_id)}
                          >
                            <div className="flex items-start gap-3">
                              <div className={`mt-1 ${notif.severity === 'high' ? 'text-red-500' : 'text-amber-500'}`}>
                                {notif.type === 'spam_complaint' ? <ShieldX className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-slate-900 truncate">{notif.title}</p>
                                <p className="text-xs text-slate-500 line-clamp-2">{notif.message}</p>
                                <p className="text-xs text-slate-400 mt-1">
                                  {new Date(notif.created_at).toLocaleString()}
                                </p>
                              </div>
                              {!notif.is_read && (
                                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              <Link to="/profile">
                <Button variant="ghost" size="icon" data-testid="profile-btn">
                  <User className="w-5 h-5" />
                </Button>
              </Link>
              <Button variant="ghost" size="icon" onClick={handleLogout} data-testid="logout-btn">
                <LogOut className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        {/* Stats Grid */}
        <StatsGrid 
          analytics={analytics} 
          pendingUsers={pendingUsers} 
          pendingWithdrawals={pendingWithdrawals} 
        />

        <Tabs defaultValue="users" className="space-y-6" onValueChange={(value) => setActiveTab(value)}>
          <TabsList className="bg-white border border-slate-200 flex-wrap h-auto">
            <TabsTrigger value="users" data-testid="users-tab">Users</TabsTrigger>
            <TabsTrigger value="groups" data-testid="groups-tab">Groups</TabsTrigger>
            <TabsTrigger value="tasks" data-testid="tasks-tab">Tasks</TabsTrigger>
            <TabsTrigger value="submissions" data-testid="submissions-tab">Pending Approval</TabsTrigger>
            <TabsTrigger value="withdrawals" data-testid="withdrawals-tab">Withdrawals</TabsTrigger>
            <TabsTrigger value="clients" data-testid="clients-tab" className="flex items-center gap-1">
              <Building2 className="w-4 h-4" />
              Clients
            </TabsTrigger>
            <TabsTrigger value="reports" data-testid="reports-tab" className="flex items-center gap-1">
              <LineChart className="w-4 h-4" />
              Reports
            </TabsTrigger>
            <TabsTrigger value="settings" data-testid="settings-tab" className="flex items-center gap-1">
              <Settings className="w-4 h-4" />
              Settings
            </TabsTrigger>
            <TabsTrigger value="support" data-testid="support-tab" className="flex items-center gap-1">
              <MessageSquare className="w-4 h-4" />
              Support
            </TabsTrigger>
            <TabsTrigger value="audit" data-testid="audit-tab" className="flex items-center gap-1">
              <History className="w-4 h-4" />
              Audit Logs
            </TabsTrigger>
          </TabsList>

          {/* Users Tab */}
          <TabsContent value="users">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex items-center justify-between">
                  <CardTitle className="font-heading text-xl">Users Management</CardTitle>
                  <div className="flex items-center gap-2">
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={() => handleExport('users')}
                      data-testid="export-users-btn"
                    >
                      <Download className="w-4 h-4 mr-2" />
                      Export CSV
                    </Button>
                    <Dialog open={addToGroupDialogOpen} onOpenChange={setAddToGroupDialogOpen}>
                      <DialogTrigger asChild>
                        <Button size="sm" variant="outline" data-testid="add-to-group-btn">
                          <UsersRound className="w-4 h-4 mr-2" />
                          Add to Group
                        </Button>
                      </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Add User to Group</DialogTitle>
                        <DialogDescription>Select a user and group</DialogDescription>
                      </DialogHeader>
                      <div className="space-y-4 pt-4">
                        <div>
                          <Label>User</Label>
                          <Select value={selectedUserForGroup} onValueChange={setSelectedUserForGroup}>
                            <SelectTrigger data-testid="select-user-for-group">
                              <SelectValue placeholder="Select user" />
                            </SelectTrigger>
                            <SelectContent>
                              {users.filter(u => u.role === "worker").map((u) => (
                                <SelectItem key={u.user_id} value={u.user_id}>
                                  {u.name} ({u.email})
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                        <div>
                          <Label>Group</Label>
                          <Select value={selectedGroup} onValueChange={setSelectedGroup}>
                            <SelectTrigger data-testid="select-group">
                              <SelectValue placeholder="Select group" />
                            </SelectTrigger>
                            <SelectContent>
                              {groups.map((g) => (
                                <SelectItem key={g.group_id} value={g.group_id}>
                                  {g.name}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                        <Button onClick={handleAddUserToGroup} className="w-full" data-testid="confirm-add-to-group-btn">
                          Add to Group
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
                
                {/* Search */}
                <div className="flex flex-wrap gap-3 items-center">
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                    <Input
                      placeholder="Search users by name or email..."
                      value={userSearch}
                      onChange={(e) => { setUserSearch(e.target.value); setUserPage(1); }}
                      className="pl-10 w-64"
                      data-testid="user-search-input"
                    />
                  </div>
                  <Select value={userStatusFilter} onValueChange={(v) => { setUserStatusFilter(v); setUserPage(1); }}>
                    <SelectTrigger className="w-40" data-testid="user-status-filter">
                      <SelectValue placeholder="Filter by status" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Status</SelectItem>
                      <SelectItem value="active">Active</SelectItem>
                      <SelectItem value="pending">Pending</SelectItem>
                      <SelectItem value="suspended">Suspended</SelectItem>
                    </SelectContent>
                  </Select>
                  {userFraudFilter && userFraudFilter !== "all" && (
                    <Badge 
                      variant="destructive" 
                      className="flex items-center gap-1 cursor-pointer"
                      onClick={() => setUserFraudFilter("all")}
                      data-testid="clear-fraud-filter"
                    >
                      <Shield className="w-3 h-3" />
                      <span className="capitalize">{userFraudFilter}</span>
                      <span className="ml-1">×</span>
                    </Badge>
                  )}
                  <Button 
                    variant={showFraudStats ? "default" : "outline"}
                    size="sm"
                    onClick={() => setShowFraudStats(!showFraudStats)}
                    className={showFraudStats ? "bg-red-600 hover:bg-red-700" : ""}
                    data-testid="toggle-fraud-stats-btn"
                  >
                    <Shield className="w-4 h-4 mr-2" />
                    Fraud Detection
                    {fraudStats?.flagged_users > 0 && (
                      <Badge className="ml-2 bg-red-500 text-white text-xs">{fraudStats.flagged_users}</Badge>
                    )}
                  </Button>
                </div>
              </div>
            </CardHeader>

              {/* Fraud Statistics Section - Togglable */}
              {showFraudStats && (
                <FraudStatsSection 
                  fraudStats={fraudStats} 
                  onFilterChange={setUserFraudFilter}
                  activeFilter={userFraudFilter}
                />
              )}

              <CardContent className="p-0">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Name</TableHead>
                      <TableHead>Email</TableHead>
                      <TableHead>Role</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Risk</TableHead>
                      <TableHead>Points</TableHead>
                      <TableHead>Groups</TableHead>
                      <TableHead>Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {users.map((u) => (
                      <TableRow key={u.user_id}>
                        <TableCell className="font-medium">{u.name}</TableCell>
                        <TableCell className="text-slate-500">{u.email}</TableCell>
                        <TableCell>
                          <Badge variant="outline" className="capitalize">
                            {u.role === "worker" ? "Gigster" : u.role?.replace("_", " ")}
                          </Badge>
                        </TableCell>
                        <TableCell>
                          <Badge
                            className={
                              u.status === "active"
                                ? "bg-green-100 text-green-700"
                                : u.status === "suspended"
                                ? "bg-red-100 text-red-700"
                                : "bg-amber-100 text-amber-700"
                            }
                          >
                            {u.status}
                          </Badge>
                        </TableCell>
                        <TableCell>
                          {u.signup_metadata?.fraud_check ? (
                            <button
                              onClick={() => handleViewFraudData(u.user_id)}
                              className="flex items-center gap-1 hover:opacity-80 transition-opacity"
                              data-testid={`view-fraud-${u.user_id}`}
                              title={`Score: ${u.signup_metadata.fraud_check.fraud_score || 0}`}
                            >
                              <Badge className={getRiskLevelBadge(u.signup_metadata.fraud_check.risk_level)}>
                                {u.signup_metadata.fraud_check.risk_level || "N/A"}
                              </Badge>
                              {u.signup_metadata.fraud_check.should_flag && (
                                <AlertTriangle className="w-4 h-4 text-red-500" />
                              )}
                            </button>
                          ) : (
                            <span className="text-xs text-slate-400">-</span>
                          )}
                        </TableCell>
                        <TableCell className="font-medium text-amber-600">
                          {u.points_balance?.toLocaleString()} pts
                        </TableCell>
                        <TableCell>
                          {u.group_ids && u.group_ids.length > 0 ? (
                            <div className="flex flex-wrap gap-1">
                              {u.group_ids.map(gid => {
                                const group = groups.find(g => g.group_id === gid);
                                return group ? (
                                  <Badge key={gid} variant="outline" className="text-xs">
                                    {group.name}
                                    <button 
                                      onClick={() => handleRemoveUserFromGroup(gid, u.user_id)}
                                      className="ml-1 text-slate-400 hover:text-red-500"
                                    >
                                      ×
                                    </button>
                                  </Badge>
                                ) : null;
                              })}
                            </div>
                          ) : (
                            <span className="text-sm text-slate-400">-</span>
                          )}
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center gap-1">
                            {u.status === "pending" && (
                              <>
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  className="text-green-600"
                                  onClick={() => handleUpdateUserStatus(u.user_id, "active")}
                                  data-testid={`approve-user-${u.user_id}`}
                                  title="Approve"
                                >
                                  <Check className="w-4 h-4" />
                                </Button>
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  className="text-red-600"
                                  onClick={() => handleUpdateUserStatus(u.user_id, "denied")}
                                  data-testid={`deny-user-${u.user_id}`}
                                  title="Deny"
                                >
                                  <Check className="w-4 h-4" />
                                </Button>
                              </>
                            )}
                            
                            {/* More Actions Dropdown */}
                            {u.role !== "admin" && (
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                                    <MoreVertical className="w-4 h-4" />
                                  </Button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end">
                                  <DropdownMenuItem
                                    onClick={() => handleImpersonate(u.user_id)}
                                    data-testid={`impersonate-${u.user_id}`}
                                  >
                                    <Eye className="w-4 h-4 mr-2" />
                                    Login as User
                                  </DropdownMenuItem>
                                  {u.role === "worker" && (
                                    <>
                                      <DropdownMenuSeparator />
                                      <DropdownMenuItem
                                        onClick={() => {
                                          setSelectedWorker(u.user_id);
                                          setAssignDialogOpen(true);
                                        }}
                                        data-testid={`assign-worker-${u.user_id}`}
                                      >
                                        <UserPlus className="w-4 h-4 mr-2" />
                                        {u.team_manager_id ? "Change Team Manager" : "Assign Team Manager"}
                                      </DropdownMenuItem>
                                      {u.team_manager_id && (
                                        <DropdownMenuItem
                                          onClick={() => handleAssignGigster(u.user_id, null)}
                                          className="text-red-600"
                                        >
                                          <X className="w-4 h-4 mr-2" />
                                          Remove Team Manager
                                        </DropdownMenuItem>
                                      )}
                                    </>
                                  )}
                                  <DropdownMenuSeparator />
                                  {u.status === "active" && (
                                    <DropdownMenuItem
                                      onClick={() => handleUpdateUserStatus(u.user_id, "suspended")}
                                      className="text-amber-600"
                                      data-testid={`suspend-user-${u.user_id}`}
                                    >
                                      <Ban className="w-4 h-4 mr-2" />
                                      Suspend User
                                    </DropdownMenuItem>
                                  )}
                                  {u.status === "suspended" && (
                                    <DropdownMenuItem
                                      onClick={() => handleUpdateUserStatus(u.user_id, "active")}
                                      className="text-green-600"
                                      data-testid={`reactivate-user-${u.user_id}`}
                                    >
                                      <Check className="w-4 h-4 mr-2" />
                                      Reactivate User
                                    </DropdownMenuItem>
                                  )}
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleViewFraudData(u.user_id)}
                                    data-testid={`view-fraud-menu-${u.user_id}`}
                                  >
                                    <Shield className="w-4 h-4 mr-2" />
                                    View Fraud Data
                                  </DropdownMenuItem>
                                </DropdownMenuContent>
                              </DropdownMenu>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                
                {/* Pagination */}
                {userTotalPages > 1 && (
                  <div className="flex items-center justify-between px-4 py-3 border-t">
                    <span className="text-sm text-slate-500">
                      Page {userPage} of {userTotalPages}
                    </span>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setUserPage(p => Math.max(1, p - 1))}
                        disabled={userPage === 1}
                      >
                        <ChevronLeft className="w-4 h-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setUserPage(p => Math.min(userTotalPages, p + 1))}
                        disabled={userPage === userTotalPages}
                      >
                        <ChevronRight className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>

            {/* Assign Gigster Dialog */}
            <Dialog open={assignDialogOpen} onOpenChange={setAssignDialogOpen}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Assign Gigster to Team Manager</DialogTitle>
                  <DialogDescription>Select a team manager for this gigster</DialogDescription>
                </DialogHeader>
                <div className="space-y-4 pt-4">
                  <div>
                    <Label>Team Manager</Label>
                    <Select value={selectedManager} onValueChange={setSelectedManager}>
                      <SelectTrigger data-testid="select-manager">
                        <SelectValue placeholder="Select team manager" />
                      </SelectTrigger>
                      <SelectContent>
                        {teamManagers.map((m) => (
                          <SelectItem key={m.user_id} value={m.user_id}>
                            {m.name} ({m.email})
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <Button onClick={handleAssignGigster} className="w-full" data-testid="confirm-assign-btn">
                    Assign Gigster
                  </Button>
                </div>
              </DialogContent>
            </Dialog>

            {/* Pending Payment Approvals */}
            {pendingPaymentApprovals.length > 0 && (
              <Card className="border-amber-200 bg-amber-50 mt-6">
                <CardHeader className="border-b border-amber-200">
                  <CardTitle className="font-heading text-xl flex items-center gap-2 text-amber-800">
                    <DollarSign className="w-5 h-5" />
                    Pending Payment Approvals ({pendingPaymentApprovals.length})
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>User</TableHead>
                        <TableHead>Email</TableHead>
                        <TableHead>Requested Changes</TableHead>
                        <TableHead>Requested At</TableHead>
                        <TableHead>Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {pendingPaymentApprovals.map((u) => (
                        <TableRow key={u.user_id || u.email}>
                          <TableCell className="font-medium">{u.name}</TableCell>
                          <TableCell className="text-slate-500">{u.email}</TableCell>
                          <TableCell>
                            <div className="text-sm space-y-1">
                              {u.pending_payment_details?.payment_method && (
                                <p><span className="text-slate-500">Payment Method:</span> <span className="font-medium">{u.pending_payment_details.payment_method}</span></p>
                              )}
                              {u.pending_payment_details?.paypal_email && (
                                <p><span className="text-slate-500">PayPal:</span> <span className="font-medium">{u.pending_payment_details.paypal_email}</span></p>
                              )}
                            </div>
                          </TableCell>
                          <TableCell className="text-slate-500 text-sm">
                            {u.pending_payment_details?.requested_at 
                              ? new Date(u.pending_payment_details.requested_at).toLocaleString()
                              : "-"}
                          </TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button
                                size="sm"
                                variant="default"
                                className="bg-green-600 hover:bg-green-700"
                                onClick={() => handlePaymentApproval(u.user_id, "approve")}
                                data-testid={`approve-payment-${u.user_id}`}
                              >
                                <Check className="w-4 h-4 mr-1" />
                                Approve
                              </Button>
                              <Button
                                size="sm"
                                variant="destructive"
                                onClick={() => handlePaymentApproval(u.user_id, "reject")}
                                data-testid={`reject-payment-${u.user_id}`}
                              >
                                <X className="w-4 h-4 mr-1" />
                                Reject
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            )}
          </TabsContent>

          {/* Groups Tab */}
          <TabsContent value="groups">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex items-center justify-between">
                  <CardTitle className="font-heading text-xl">User Groups</CardTitle>
                  <Dialog open={groupDialogOpen} onOpenChange={setGroupDialogOpen}>
                    <DialogTrigger asChild>
                      <Button size="sm" data-testid="create-group-btn">
                        <Plus className="w-4 h-4 mr-2" />
                        Create Group
                      </Button>
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Create New Group</DialogTitle>
                        <DialogDescription>Create a group to organize gigsters (e.g., US, Japan)</DialogDescription>
                      </DialogHeader>
                      <div className="space-y-4 pt-4">
                        <div>
                          <Label>Group Name</Label>
                          <Input
                            value={groupForm.name}
                            onChange={(e) => setGroupForm({ ...groupForm, name: e.target.value })}
                            placeholder="e.g., US Gigsters, Japan Team"
                            data-testid="group-name-input"
                          />
                        </div>
                        <div>
                          <Label>Description (Optional)</Label>
                          <Textarea
                            value={groupForm.description}
                            onChange={(e) => setGroupForm({ ...groupForm, description: e.target.value })}
                            placeholder="Group description"
                            data-testid="group-description-input"
                          />
                        </div>
                        <Button onClick={handleCreateGroup} className="w-full" data-testid="save-group-btn">
                          Create Group
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </CardHeader>
              <CardContent className="p-0">
                {groups.length === 0 ? (
                  <div className="p-8 text-center text-slate-500">
                    <UsersRound className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                    <p>No groups created yet</p>
                    <p className="text-sm">Create groups to organize gigsters by region or team</p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Description</TableHead>
                        <TableHead>Team Manager</TableHead>
                        <TableHead>Members</TableHead>
                        <TableHead>Created</TableHead>
                        <TableHead>Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {groups.map((group) => (
                        <TableRow key={group.group_id}>
                          <TableCell className="font-medium">{group.name}</TableCell>
                          <TableCell className="text-slate-500">{group.description || "-"}</TableCell>
                          <TableCell>
                            <Select 
                              value={group.team_manager_id || "none"} 
                              onValueChange={(v) => handleAssignGroupToManager(group.group_id, v === "none" ? null : v)}
                            >
                              <SelectTrigger className="w-40" data-testid={`group-manager-${group.group_id}`}>
                                <SelectValue placeholder="Assign manager" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="none">No manager</SelectItem>
                                {teamManagers.map((m) => (
                                  <SelectItem key={m.user_id} value={m.user_id}>
                                    {m.name}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline">{group.member_count || 0} members</Badge>
                          </TableCell>
                          <TableCell className="text-slate-500">
                            {new Date(group.created_at).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-red-600"
                              onClick={() => handleDeleteGroup(group.group_id)}
                              data-testid={`delete-group-${group.group_id}`}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Tasks Tab */}
          <TabsContent value="tasks">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl">Tasks Management</CardTitle>
                      {taskStats && (
                        <div className="flex gap-3 mt-2 text-sm">
                          <span className="text-green-600">{taskStats.active} active</span>
                          <span className="text-slate-400">|</span>
                          <span className="text-slate-500">{taskStats.inactive} inactive</span>
                          <span className="text-slate-400">|</span>
                          <span className="text-amber-600">{taskStats.archived} archived</span>
                        </div>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleExport('tasks')}
                        data-testid="export-tasks-btn"
                      >
                        <Download className="w-4 h-4 mr-1" />
                        Export CSV
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={handleAutoArchiveOldTasks}
                        title="Archive inactive tasks older than 60 days"
                      >
                        <Archive className="w-4 h-4 mr-1" />
                        Auto Archive (60d)
                      </Button>
                      <Dialog open={taskDialogOpen} onOpenChange={(open) => {
                        setTaskDialogOpen(open);
                        if (!open) {
                          setEditingTask(null);
                          setTaskForm({
                            title: "",
                            description: "",
                            task_type: "click_url",
                            completion_method: "auto",
                            points_reward: 10,
                            instructions: "",
                            target_url: "",
                            client_id: "",
                            email_domain_id: "",
                            email_subject: "",
                            email_body: "",
                            availability_hours: 24,
                            completion_minutes: 10,
                            scheduled_at: "",
                            group_ids: [],
                            max_completions: "",
                            is_active: true
                          });
                        }
                      }}>
                        <DialogTrigger asChild>
                          <Button size="sm" data-testid="create-task-btn">
                            <Plus className="w-4 h-4 mr-2" />
                            Create Task
                          </Button>
                        </DialogTrigger>
                    <DialogContent className="max-w-lg">
                      <DialogHeader>
                        <DialogTitle>{editingTask ? "Edit Task" : "Create New Task"}</DialogTitle>
                        <DialogDescription>{editingTask ? "Update task details" : "Add a new task for gigsters to complete"}</DialogDescription>
                      </DialogHeader>
                      <div className="space-y-4 pt-4 max-h-[60vh] overflow-y-auto">
                        {/* Client Selection - Required */}
                        <div>
                          <Label>Client <span className="text-red-500">*</span></Label>
                          <Select 
                            value={taskForm.client_id} 
                            onValueChange={(v) => setTaskForm({ ...taskForm, client_id: v, email_domain_id: "" })}
                          >
                            <SelectTrigger data-testid="task-client-select">
                              <SelectValue placeholder="Select a client" />
                            </SelectTrigger>
                            <SelectContent>
                              {clients.filter(c => c.is_active !== false).map((c) => (
                                <SelectItem key={c.client_id} value={c.client_id}>
                                  {c.name}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                        <div>
                          <Label>Title</Label>
                          <Input
                            value={taskForm.title}
                            onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
                            placeholder="Task title"
                            data-testid="task-title-input"
                          />
                        </div>
                        <div>
                          <Label>Description</Label>
                          <Textarea
                            value={taskForm.description}
                            onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
                            placeholder="Task description"
                            data-testid="task-description-input"
                          />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <Label>Task Type</Label>
                            <Select value={taskForm.task_type} onValueChange={(v) => setTaskForm({ ...taskForm, task_type: v })}>
                              <SelectTrigger data-testid="task-type-select">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="click_url">Click URL</SelectItem>
                                <SelectItem value="reply_email">Reply Email</SelectItem>
                                <SelectItem value="social_post">Social Post</SelectItem>
                                <SelectItem value="social_review">Social Review</SelectItem>
                                <SelectItem value="custom">Custom Task</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>
                          <div>
                            <Label>Completion Method</Label>
                            <Select value={taskForm.completion_method} onValueChange={(v) => setTaskForm({ ...taskForm, completion_method: v })}>
                              <SelectTrigger data-testid="completion-method-select">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="auto">Auto (for click_url)</SelectItem>
                                <SelectItem value="manual">Manual Review</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>
                        </div>
                        <div>
                          <Label>Points Reward</Label>
                          <Input
                            type="number"
                            value={taskForm.points_reward}
                            onChange={(e) => setTaskForm({ ...taskForm, points_reward: parseFloat(e.target.value) })}
                            data-testid="points-reward-input"
                          />
                        </div>
                        <div>
                          <Label>Instructions</Label>
                          <Textarea
                            value={taskForm.instructions}
                            onChange={(e) => setTaskForm({ ...taskForm, instructions: e.target.value })}
                            placeholder={taskForm.task_type === "custom" ? "Describe exactly what the gigster needs to do..." : "Detailed instructions for gigsters"}
                            rows={taskForm.task_type === "custom" ? 6 : 3}
                            data-testid="task-instructions-input"
                          />
                        </div>
                        {taskForm.task_type === "click_url" && (
                          <div>
                            <Label>Target URL</Label>
                            <Input
                              value={taskForm.target_url}
                              onChange={(e) => setTaskForm({ ...taskForm, target_url: e.target.value })}
                              placeholder="https://..."
                              data-testid="target-url-input"
                            />
                          </div>
                        )}
                        
                        {/* Time Limits */}
                        <div className="border-t border-slate-200 pt-4 mt-4">
                          <h4 className="font-medium text-slate-900 mb-3">Time Limits</h4>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label>Availability (hours)</Label>
                              <Input
                                type="number"
                                value={taskForm.availability_hours}
                                onChange={(e) => setTaskForm({ ...taskForm, availability_hours: parseInt(e.target.value) })}
                                data-testid="availability-hours-input"
                              />
                              <p className="text-xs text-slate-500 mt-1">Task available for this duration</p>
                            </div>
                            <div>
                              <Label>Completion Time (minutes)</Label>
                              <Input
                                type="number"
                                value={taskForm.completion_minutes}
                                onChange={(e) => setTaskForm({ ...taskForm, completion_minutes: parseInt(e.target.value) })}
                                data-testid="completion-minutes-input"
                              />
                              <p className="text-xs text-slate-500 mt-1">Must complete within this time after starting</p>
                            </div>
                          </div>
                          <div className="mt-3">
                            <Label>Max Completions (optional)</Label>
                            <Input
                              type="number"
                              placeholder="Unlimited"
                              value={taskForm.max_completions}
                              onChange={(e) => setTaskForm({ ...taskForm, max_completions: e.target.value ? parseInt(e.target.value) : "" })}
                              data-testid="max-completions-input"
                            />
                            <p className="text-xs text-slate-500 mt-1">Leave empty for unlimited. Task stops accepting after reaching limit.</p>
                          </div>
                        </div>

                        {/* Schedule Task */}
                        <div className="border-t border-slate-200 pt-4 mt-4">
                          <h4 className="font-medium text-slate-900 mb-3 flex items-center gap-2">
                            <Calendar className="w-4 h-4" />
                            Schedule Task
                          </h4>
                          <div className="space-y-3">
                            {/* Schedule Mode Toggle */}
                            <div className="flex items-center gap-4">
                              <div className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  id="schedule-now"
                                  name="schedule-mode"
                                  checked={!taskForm.scheduled_at && taskForm.schedule_slots.length === 0}
                                  onChange={() => setTaskForm({ ...taskForm, scheduled_at: "", schedule_slots: [] })}
                                  className="w-4 h-4"
                                />
                                <Label htmlFor="schedule-now" className="font-normal cursor-pointer">Publish Now</Label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  id="schedule-single"
                                  name="schedule-mode"
                                  checked={!!taskForm.scheduled_at && taskForm.schedule_slots.length === 0}
                                  onChange={() => {
                                    const tomorrow = new Date();
                                    tomorrow.setDate(tomorrow.getDate() + 1);
                                    tomorrow.setHours(9, 0, 0, 0);
                                    setTaskForm({ ...taskForm, scheduled_at: tomorrow.toISOString(), schedule_slots: [] });
                                  }}
                                  className="w-4 h-4"
                                />
                                <Label htmlFor="schedule-single" className="font-normal cursor-pointer">Single Schedule</Label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  id="schedule-advanced"
                                  name="schedule-mode"
                                  checked={taskForm.schedule_slots.length > 0}
                                  onChange={() => {
                                    const tomorrow = new Date();
                                    tomorrow.setDate(tomorrow.getDate() + 1);
                                    setTaskForm({ 
                                      ...taskForm, 
                                      scheduled_at: "", 
                                      schedule_slots: [{ date: tomorrow.toISOString().split('T')[0], time: "09:00" }]
                                    });
                                  }}
                                  className="w-4 h-4"
                                />
                                <Label htmlFor="schedule-advanced" className="font-normal cursor-pointer">
                                  Advanced Schedule
                                  <Badge className="ml-2 bg-emerald-100 text-emerald-700 text-xs">Multiple Days</Badge>
                                </Label>
                              </div>
                            </div>
                            
                            {/* Single Schedule */}
                            {taskForm.scheduled_at && taskForm.schedule_slots.length === 0 && (
                              <div className="ml-6 space-y-2 bg-slate-50 p-3 rounded-lg">
                                <Input
                                  type="datetime-local"
                                  value={taskForm.scheduled_at ? new Date(taskForm.scheduled_at).toISOString().slice(0, 16) : ""}
                                  onChange={(e) => setTaskForm({ ...taskForm, scheduled_at: e.target.value ? new Date(e.target.value).toISOString() : "" })}
                                  className="max-w-xs"
                                  data-testid="scheduled-at-input"
                                />
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center gap-2">
                                  <Clock className="w-4 h-4 text-blue-600" />
                                  <p className="text-sm text-blue-800">
                                    Task will become visible on{" "}
                                    <strong>{new Date(taskForm.scheduled_at).toLocaleDateString()}</strong> at{" "}
                                    <strong>{new Date(taskForm.scheduled_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</strong>
                                  </p>
                                </div>
                              </div>
                            )}
                            
                            {/* Advanced Schedule - Multiple Slots */}
                            {taskForm.schedule_slots.length > 0 && (
                              <div className="ml-6 space-y-3 bg-slate-50 p-3 rounded-lg">
                                <p className="text-sm text-slate-600">Add multiple schedule times:</p>
                                
                                {taskForm.schedule_slots.map((slot, index) => (
                                  <div key={index} className="flex items-center gap-3 bg-white p-2 rounded border border-slate-200">
                                    <Input
                                      type="date"
                                      value={slot.date}
                                      onChange={(e) => {
                                        const newSlots = [...taskForm.schedule_slots];
                                        newSlots[index] = { ...slot, date: e.target.value };
                                        setTaskForm({ ...taskForm, schedule_slots: newSlots });
                                      }}
                                      className="w-40"
                                      min={new Date().toISOString().split('T')[0]}
                                    />
                                    <Input
                                      type="time"
                                      value={slot.time}
                                      onChange={(e) => {
                                        const newSlots = [...taskForm.schedule_slots];
                                        newSlots[index] = { ...slot, time: e.target.value };
                                        setTaskForm({ ...taskForm, schedule_slots: newSlots });
                                      }}
                                      className="w-32"
                                    />
                                    <Button
                                      type="button"
                                      variant="ghost"
                                      size="sm"
                                      onClick={() => {
                                        const newSlots = taskForm.schedule_slots.filter((_, i) => i !== index);
                                        setTaskForm({ ...taskForm, schedule_slots: newSlots });
                                      }}
                                      className="text-red-500 hover:text-red-700 hover:bg-red-50"
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </Button>
                                  </div>
                                ))}
                                
                                <Button
                                  type="button"
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    const lastSlot = taskForm.schedule_slots[taskForm.schedule_slots.length - 1];
                                    const nextDate = new Date(lastSlot.date);
                                    nextDate.setDate(nextDate.getDate() + 1);
                                    setTaskForm({
                                      ...taskForm,
                                      schedule_slots: [
                                        ...taskForm.schedule_slots,
                                        { date: nextDate.toISOString().split('T')[0], time: lastSlot.time }
                                      ]
                                    });
                                  }}
                                  className="w-full"
                                >
                                  <Plus className="w-4 h-4 mr-2" />
                                  Add Another Schedule
                                </Button>
                                
                                {/* Preview of scheduled times */}
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                                  <p className="text-sm font-medium text-blue-800 mb-2">Task will go live at:</p>
                                  <div className="space-y-1">
                                    {taskForm.schedule_slots
                                      .filter(s => s.date && s.time)
                                      .sort((a, b) => new Date(`${a.date}T${a.time}`) - new Date(`${b.date}T${b.time}`))
                                      .map((slot, i) => (
                                        <div key={i} className="flex items-center gap-2 text-sm text-blue-700">
                                          <Clock className="w-3 h-3" />
                                          <span>{new Date(`${slot.date}T${slot.time}`).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })}</span>
                                          <span>at</span>
                                          <strong>{slot.time}</strong>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            )}
                            
                            {/* No schedule selected */}
                            {!taskForm.scheduled_at && taskForm.schedule_slots.length === 0 && (
                              <p className="text-xs text-slate-500 ml-6">Task will be visible immediately after creation</p>
                            )}
                          </div>
                        </div>

                        {/* Group Restriction */}
                        <div className="border-t border-slate-200 pt-4 mt-4">
                          <h4 className="font-medium text-slate-900 mb-3">Group Access (Optional)</h4>
                          <div>
                            <Label>Restrict to Groups</Label>
                            <div className="flex flex-wrap gap-2 mt-2">
                              {groups.map((g) => (
                                <label key={g.group_id} className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 cursor-pointer hover:bg-slate-50">
                                  <input
                                    type="checkbox"
                                    checked={taskForm.group_ids.includes(g.group_id)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setTaskForm({ ...taskForm, group_ids: [...taskForm.group_ids, g.group_id] });
                                      } else {
                                        setTaskForm({ ...taskForm, group_ids: taskForm.group_ids.filter(id => id !== g.group_id) });
                                      }
                                    }}
                                    className="h-4 w-4"
                                  />
                                  <span className="text-sm">{g.name}</span>
                                </label>
                              ))}
                              {groups.length === 0 && (
                                <p className="text-sm text-slate-500">No groups created yet</p>
                              )}
                            </div>
                            <p className="text-xs text-slate-500 mt-2">Leave unchecked to make task visible to all gigsters</p>
                          </div>
                        </div>

                        {/* Email Settings - Only for email tasks */}
                        {(taskForm.task_type === "click_url" || taskForm.task_type === "reply_email") && (
                          <div className="border-t border-slate-200 pt-4 mt-4">
                            <h4 className="font-medium text-slate-900 mb-3">Email Settings (Optional)</h4>
                            <div className="space-y-3">
                              <div>
                                <Label>Email Domain</Label>
                                <Select 
                                  value={taskForm.email_domain_id || "none"} 
                                  onValueChange={(v) => setTaskForm({ ...taskForm, email_domain_id: v === "none" ? "" : v })}
                                >
                                  <SelectTrigger data-testid="email-domain-select">
                                    <SelectValue placeholder="Select domain for sending emails" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="none">None (no email)</SelectItem>
                                    {domains
                                      .filter(d => !taskForm.client_id || d.client_id === taskForm.client_id)
                                      .map((d) => (
                                        <SelectItem key={d.domain_id} value={d.domain_id}>
                                          {d.domain} ({d.from_email})
                                        </SelectItem>
                                      ))}
                                    {domains.length === 0 && (
                                      <SelectItem value="no-domains" disabled>
                                        No domains configured
                                      </SelectItem>
                                    )}
                                    {taskForm.client_id && domains.filter(d => d.client_id === taskForm.client_id).length === 0 && domains.length > 0 && (
                                      <SelectItem value="no-client-domains" disabled>
                                        No domains for this client
                                      </SelectItem>
                                    )}
                                  </SelectContent>
                                </Select>
                                {!taskForm.client_id && domains.length > 0 && (
                                  <p className="text-xs text-slate-500 mt-1">Tip: Select a client to filter domains for that client</p>
                                )}
                              </div>
                              {taskForm.email_domain_id && (
                                <>
                                  <div>
                                    <Label>Email Subject</Label>
                                    <Input
                                      value={taskForm.email_subject}
                                      onChange={(e) => setTaskForm({ ...taskForm, email_subject: e.target.value })}
                                      placeholder="Leave empty for default subject"
                                      data-testid="email-subject-input"
                                    />
                                    <div className="flex flex-wrap gap-1 mt-1">
                                      <span className="text-xs text-slate-500">Insert:</span>
                                      {[
                                        { label: "First Name", value: "{{FIRST_NAME}}" },
                                        { label: "Last Name", value: "{{LAST_NAME}}" },
                                        { label: "Full Name", value: "{{FULL_NAME}}" },
                                      ].map((v) => (
                                        <button
                                          key={v.value}
                                          type="button"
                                          onClick={() => setTaskForm({ ...taskForm, email_subject: (taskForm.email_subject || "") + v.value })}
                                          className="text-xs px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded hover:bg-emerald-200 transition-colors"
                                        >
                                          {v.label}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="flex items-center justify-between mb-1">
                                      <Label>Email Body (HTML)</Label>
                                      {taskForm.email_body && (
                                        <Button
                                          type="button"
                                          variant="outline"
                                          size="sm"
                                          onClick={() => setShowEmailPreview(true)}
                                          data-testid="preview-email-btn"
                                        >
                                          <Eye className="w-4 h-4 mr-1" />
                                          Preview
                                        </Button>
                                      )}
                                    </div>
                                    <Textarea
                                      value={taskForm.email_body}
                                      onChange={(e) => setTaskForm({ ...taskForm, email_body: e.target.value })}
                                      placeholder="Leave empty for default template. Use variables below for personalization."
                                      rows={6}
                                      data-testid="email-body-input"
                                    />
                                    <div className="flex flex-wrap gap-1 mt-2">
                                      <span className="text-xs text-slate-500">Insert:</span>
                                      {[
                                        { label: "First Name", value: "{{FIRST_NAME}}" },
                                        { label: "Last Name", value: "{{LAST_NAME}}" },
                                        { label: "Full Name", value: "{{FULL_NAME}}" },
                                        { label: "Email", value: "{{EMAIL}}" },
                                        { label: "Tracking URL", value: "{{TRACKING_URL}}" },
                                      ].map((v) => (
                                        <button
                                          key={v.value}
                                          type="button"
                                          onClick={() => setTaskForm({ ...taskForm, email_body: (taskForm.email_body || "") + v.value })}
                                          className={`text-xs px-2 py-0.5 rounded transition-colors ${
                                            v.value === "{{TRACKING_URL}}" 
                                              ? "bg-blue-100 text-blue-700 hover:bg-blue-200" 
                                              : "bg-emerald-100 text-emerald-700 hover:bg-emerald-200"
                                          }`}
                                        >
                                          {v.label}
                                        </button>
                                      ))}
                                    </div>
                                    <p className="text-xs text-slate-500 mt-1">
                                      <strong>Note:</strong> <code className="bg-blue-100 px-1 rounded text-blue-700">{"{{TRACKING_URL}}"}</code> is required for auto-completion.
                                      Personalization variables will be replaced with the Gigster's actual data.
                                    </p>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        )}

                        <Button onClick={handleCreateTask} className="w-full" data-testid="save-task-btn">
                          {editingTask ? "Update Task" : "Create Task"}
                        </Button>
                      </div>
                    </DialogContent>
                  </Dialog>
                  
                  {/* Email Preview Modal */}
                  <Dialog open={showEmailPreview} onOpenChange={setShowEmailPreview}>
                    <DialogContent className="max-w-3xl max-h-[90vh]">
                      <DialogHeader>
                        <DialogTitle className="flex items-center gap-2">
                          <Eye className="w-5 h-5" />
                          Email Preview
                        </DialogTitle>
                        <DialogDescription>
                          Preview how the email will appear to recipients
                        </DialogDescription>
                      </DialogHeader>
                      <div className="space-y-4">
                        {/* Email Header Info */}
                        <div className="bg-slate-50 rounded-lg p-4 space-y-2">
                          <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-slate-500 w-16">From:</span>
                            <span className="text-sm">
                              {domains.find(d => d.domain_id === taskForm.email_domain_id)?.from_name || "GigsEasy"} 
                              &lt;{domains.find(d => d.domain_id === taskForm.email_domain_id)?.from_email || "noreply@example.com"}&gt;
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-slate-500 w-16">To:</span>
                            <span className="text-sm text-slate-400">recipient@example.com</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-slate-500 w-16">Subject:</span>
                            <span className="text-sm font-medium">
                              {taskForm.email_subject || `New Task: ${taskForm.title || "Task Title"} (+${taskForm.points_reward || 0} pts)`}
                            </span>
                          </div>
                        </div>
                        
                        {/* Email Body Preview */}
                        <div className="border border-slate-200 rounded-lg overflow-hidden">
                          <div className="bg-slate-100 px-4 py-2 border-b border-slate-200 flex items-center justify-between">
                            <span className="text-xs font-medium text-slate-500">EMAIL BODY</span>
                            <Badge variant="outline" className="text-xs">HTML Rendered</Badge>
                          </div>
                          <div 
                            className="p-4 bg-white max-h-[400px] overflow-y-auto"
                            style={{ minHeight: "200px" }}
                          >
                            {taskForm.email_body ? (
                              <div 
                                className="prose prose-sm max-w-none"
                                dangerouslySetInnerHTML={{ 
                                  __html: taskForm.email_body
                                    .replace(/\{\{TRACKING_URL\}\}/g, '<a href="#" style="color: #2563eb; text-decoration: underline;">[Tracked Link]</a>')
                                    .replace(/\{\{USER_NAME\}\}/g, '<strong>John Doe</strong>')
                                    .replace(/\{\{TASK_TITLE\}\}/g, `<strong>${taskForm.title || "Task Title"}</strong>`)
                                    .replace(/\{\{POINTS\}\}/g, `<strong>${taskForm.points_reward || 0}</strong>`)
                                }}
                              />
                            ) : (
                              <div className="text-center text-slate-400 py-8">
                                <Mail className="w-12 h-12 mx-auto mb-2 opacity-50" />
                                <p>No custom email body. Default template will be used.</p>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Placeholder Legend */}
                        <div className="bg-blue-50 rounded-lg p-4">
                          <h4 className="text-sm font-medium text-blue-800 mb-2">Available Placeholders</h4>
                          <div className="grid grid-cols-2 gap-2 text-xs text-blue-700">
                            <div><code className="bg-blue-100 px-1 rounded">{"{{TRACKING_URL}}"}</code> - Tracked click link</div>
                            <div><code className="bg-blue-100 px-1 rounded">{"{{USER_NAME}}"}</code> - Recipient's name</div>
                            <div><code className="bg-blue-100 px-1 rounded">{"{{TASK_TITLE}}"}</code> - Task title</div>
                            <div><code className="bg-blue-100 px-1 rounded">{"{{POINTS}}"}</code> - Points reward</div>
                          </div>
                        </div>
                        
                        <div className="flex justify-end gap-2">
                          <Button variant="outline" onClick={() => setShowEmailPreview(false)}>
                            Close
                          </Button>
                        </div>
                      </div>
                    </DialogContent>
                  </Dialog>
                  
                  {/* Send Task Emails Dialog */}
                  <Dialog open={sendEmailsDialogOpen} onOpenChange={setSendEmailsDialogOpen}>
                    <DialogContent className="max-w-md">
                      <DialogHeader>
                        <DialogTitle>Send Task Emails</DialogTitle>
                        <DialogDescription>
                          Send email notifications for "{selectedTaskForEmail?.title}" to gigsters
                        </DialogDescription>
                      </DialogHeader>
                      <div className="space-y-4 pt-4">
                        <div>
                          <Label>Sending Domain <span className="text-red-500">*</span></Label>
                          <Select 
                            value={sendEmailsForm.domain_id} 
                            onValueChange={(v) => setSendEmailsForm({ ...sendEmailsForm, domain_id: v })}
                          >
                            <SelectTrigger data-testid="send-email-domain-select">
                              <SelectValue placeholder="Select a domain" />
                            </SelectTrigger>
                            <SelectContent>
                              {domains.filter(d => d.is_active !== false).map((d) => (
                                <SelectItem key={d.domain_id} value={d.domain_id}>
                                  {d.domain} ({d.from_email})
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                          <p className="text-xs text-slate-500 mt-1">
                            Emails will be sent via SparkPost using this domain's API key
                          </p>
                        </div>
                        
                        <div>
                          <Label>Filter by Groups (Optional)</Label>
                          <Select 
                            value={sendEmailsForm.group_ids[0] || "all"} 
                            onValueChange={(v) => setSendEmailsForm({ 
                              ...sendEmailsForm, 
                              group_ids: v === "all" ? [] : [v] 
                            })}
                          >
                            <SelectTrigger>
                              <SelectValue placeholder="All gigsters" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">All Gigsters</SelectItem>
                              {groups.map((g) => (
                                <SelectItem key={g.group_id} value={g.group_id}>
                                  {g.name}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                        
                        <div>
                          <Label>Filter by Country (Optional)</Label>
                          <Input
                            value={sendEmailsForm.country}
                            onChange={(e) => setSendEmailsForm({ ...sendEmailsForm, country: e.target.value })}
                            placeholder="e.g., USA, UK, Canada"
                          />
                        </div>
                        
                        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                          <p className="text-sm text-amber-800">
                            <strong>Note:</strong> Emails will only be sent to active gigsters with verified Gmail addresses.
                          </p>
                        </div>
                        
                        <div className="flex gap-2 pt-2">
                          <Button 
                            variant="outline" 
                            className="flex-1"
                            onClick={() => {
                              setSendEmailsDialogOpen(false);
                              setSelectedTaskForEmail(null);
                              setSendEmailsForm({ domain_id: "", group_ids: [], country: "" });
                            }}
                          >
                            Cancel
                          </Button>
                          <Button 
                            className="flex-1"
                            onClick={handleSendTaskEmails}
                            disabled={sendingEmails || !sendEmailsForm.domain_id}
                            data-testid="confirm-send-emails-btn"
                          >
                            {sendingEmails ? "Sending..." : "Send Emails"}
                          </Button>
                        </div>
                      </div>
                    </DialogContent>
                  </Dialog>
                    </div>
                  </div>
                  
                  {/* Search and Filters */}
                  <div className="flex items-center gap-4">
                    <div className="relative flex-1 max-w-sm">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                      <Input
                        placeholder="Search tasks..."
                        value={taskSearch}
                        onChange={(e) => { setTaskSearch(e.target.value); setTaskPage(1); }}
                        className="pl-10"
                        data-testid="task-search-input"
                      />
                    </div>
                    <Select value={taskClientFilter} onValueChange={(v) => { setTaskClientFilter(v); setTaskPage(1); }}>
                      <SelectTrigger className="w-44" data-testid="task-client-filter">
                        <SelectValue placeholder="All Clients" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="all">All Clients</SelectItem>
                        {clients.map((c) => (
                          <SelectItem key={c.client_id} value={c.client_id}>
                            {c.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <div className="flex items-center gap-2">
                      <Button
                        variant={showArchivedTasks ? "default" : "outline"}
                        size="sm"
                        onClick={() => { setShowArchivedTasks(!showArchivedTasks); setTaskPage(1); }}
                      >
                        <Archive className="w-4 h-4 mr-1" />
                        {showArchivedTasks ? "Showing Archived" : "Show Archived"}
                      </Button>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-0">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Title</TableHead>
                      <TableHead>Client</TableHead>
                      <TableHead>Type</TableHead>
                      <TableHead>Time Limit</TableHead>
                      <TableHead>Points</TableHead>
                      <TableHead>Completions</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {tasks.map((task) => {
                      const nextScheduledAt = task.next_scheduled_at || task.scheduled_at;
                      const isScheduled = nextScheduledAt && new Date(nextScheduledAt) > new Date();
                      const hasMultipleSchedules = task.schedule_slots && task.schedule_slots.length > 1;
                      const isMaxed = task.max_completions && task.completion_count >= task.max_completions;
                      return (
                      <TableRow key={task.task_id}>
                        <TableCell>
                          <div>
                            <div className="flex items-center gap-2">
                              <p className="font-medium">{task.title}</p>
                              {isScheduled && (
                                <Badge className="bg-blue-100 text-blue-700 text-xs">
                                  <Clock className="w-3 h-3 mr-1" />
                                  {hasMultipleSchedules ? `${task.schedule_slots.length} Schedules` : "Scheduled"}
                                </Badge>
                              )}
                              {isMaxed && (
                                <Badge className="bg-orange-100 text-orange-700 text-xs">
                                  Limit Reached
                                </Badge>
                              )}
                            </div>
                            <p className="text-sm text-slate-500 truncate max-w-xs">{task.description}</p>
                            {isScheduled && nextScheduledAt && (
                              <p className="text-xs text-blue-600 mt-1">
                                Next: {new Date(nextScheduledAt).toLocaleDateString()} at {new Date(nextScheduledAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                {hasMultipleSchedules && <span className="ml-1 text-slate-500">(+{task.schedule_slots.length - 1} more)</span>}
                              </p>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <span className="text-sm text-slate-600">
                            {clients.find(c => c.client_id === task.client_id)?.name || "-"}
                          </span>
                        </TableCell>
                        <TableCell>
                          <Badge variant="outline" className="capitalize">{task.task_type?.replace("_", " ")}</Badge>
                        </TableCell>
                        <TableCell>
                          <span className="text-sm">{task.completion_minutes || 10}m</span>
                        </TableCell>
                        <TableCell className="font-medium text-amber-600">{task.points_reward} pts</TableCell>
                        <TableCell>
                          <span className={`text-sm ${isMaxed ? 'text-orange-600 font-medium' : 'text-slate-600'}`}>
                            {task.completion_count || 0}{task.max_completions ? ` / ${task.max_completions}` : ''}
                          </span>
                        </TableCell>
                        <TableCell>
                          {isScheduled ? (
                            <Badge className="bg-blue-100 text-blue-700">
                              {hasMultipleSchedules ? "Multi-Schedule" : "Scheduled"}
                            </Badge>
                          ) : (
                            <Badge className={task.is_active ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-700"}>
                              {task.is_active ? "Active" : "Inactive"}
                            </Badge>
                          )}
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center gap-1">
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-slate-600"
                              onClick={() => handleEditTask(task)}
                              title="Edit task"
                              data-testid={`edit-task-${task.task_id}`}
                            >
                              <Edit className="w-4 h-4" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-blue-600"
                              onClick={() => handleCloneTask(task.task_id)}
                              title="Clone task"
                              data-testid={`clone-task-${task.task_id}`}
                            >
                              <Copy className="w-4 h-4" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-purple-600"
                              onClick={() => {
                                setSelectedTaskForEmail(task);
                                setSendEmailsDialogOpen(true);
                              }}
                              title="Send task emails to gigsters"
                              data-testid={`send-emails-${task.task_id}`}
                            >
                              <Mail className="w-4 h-4" />
                            </Button>
                            {!task.is_archived ? (
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-amber-600"
                                onClick={() => handleArchiveTask(task.task_id)}
                                title="Archive task"
                              >
                                <Archive className="w-4 h-4" />
                              </Button>
                            ) : (
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-green-600"
                                onClick={() => handleUnarchiveTask(task.task_id)}
                                title="Unarchive task"
                              >
                                <CheckCircle className="w-4 h-4" />
                              </Button>
                            )}
                            <Button
                              variant="ghost"
                              size="icon"
                              className="text-red-600"
                              onClick={() => handleDeleteTask(task.task_id)}
                              data-testid={`delete-task-${task.task_id}`}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                
                {/* Pagination */}
                {taskTotalPages > 1 && (
                  <div className="flex items-center justify-between px-4 py-3 border-t">
                    <span className="text-sm text-slate-500">
                      Page {taskPage} of {taskTotalPages}
                    </span>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setTaskPage(p => Math.max(1, p - 1))}
                        disabled={taskPage === 1}
                      >
                        <ChevronLeft className="w-4 h-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setTaskPage(p => Math.min(taskTotalPages, p + 1))}
                        disabled={taskPage === taskTotalPages}
                      >
                        <ChevronRight className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Submissions Tab */}
          <TabsContent value="submissions">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl">Pending Approval</CardTitle>
                      {submissionStats && (
                        <div className="flex gap-3 mt-2 text-sm">
                          <span className="text-amber-600">{submissionStats.pending} pending</span>
                          <span className="text-slate-400">|</span>
                          <span className="text-green-600">{submissionStats.approved} approved</span>
                          <span className="text-slate-400">|</span>
                          <span className="text-red-600">{submissionStats.rejected} rejected</span>
                          <span className="text-slate-400">|</span>
                          <span className="text-slate-500">{submissionStats.archived} archived</span>
                        </div>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleExport('submissions')}
                        data-testid="export-submissions-btn"
                      >
                        <Download className="w-4 h-4 mr-1" />
                        Export CSV
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={handleAutoArchiveOldSubmissions}
                        title="Archive reviewed submissions older than 60 days"
                      >
                        <Archive className="w-4 h-4 mr-1" />
                        Auto Archive (60d)
                      </Button>
                    </div>
                  </div>
                  
                  {/* Filters */}
                  <div className="flex flex-wrap items-center gap-3">
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                      <Input
                        placeholder="Search by gigster or task..."
                        value={submissionSearch}
                        onChange={(e) => { setSubmissionSearch(e.target.value); setSubmissionPage(1); }}
                        className="pl-10 w-64"
                        data-testid="submission-search-input"
                      />
                    </div>
                    <Select value={submissionStatusFilter} onValueChange={(v) => { setSubmissionStatusFilter(v); setSubmissionPage(1); }}>
                      <SelectTrigger className="w-36" data-testid="submission-status-filter">
                        <SelectValue placeholder="Status" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="all">All Status</SelectItem>
                        <SelectItem value="pending">Pending</SelectItem>
                        <SelectItem value="approved">Approved</SelectItem>
                        <SelectItem value="rejected">Rejected</SelectItem>
                      </SelectContent>
                    </Select>
                    <Input
                      type="date"
                      value={submissionDateFilter}
                      onChange={(e) => { setSubmissionDateFilter(e.target.value); setSubmissionPage(1); }}
                      className="w-40"
                      data-testid="submission-date-filter"
                    />
                    {(submissionSearch || submissionStatusFilter !== "all" || submissionDateFilter) && (
                      <Button 
                        variant="ghost" 
                        size="sm"
                        onClick={() => {
                          setSubmissionSearch("");
                          setSubmissionStatusFilter("all");
                          setSubmissionDateFilter("");
                          setSubmissionPage(1);
                        }}
                      >
                        Clear Filters
                      </Button>
                    )}
                    <Button
                      variant={showArchivedSubmissions ? "default" : "outline"}
                      size="sm"
                      onClick={() => { setShowArchivedSubmissions(!showArchivedSubmissions); setSubmissionPage(1); }}
                    >
                      <Archive className="w-4 h-4 mr-1" />
                      {showArchivedSubmissions ? "Showing Archived" : "Show Archived"}
                    </Button>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-0">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Gigster</TableHead>
                      <TableHead>Task</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Points</TableHead>
                      <TableHead>Submitted</TableHead>
                      <TableHead>Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {submissions.map((submission) => (
                      <TableRow key={submission.submission_id}>
                        <TableCell>
                          <div>
                            <p className="font-medium">{submission.worker?.name}</p>
                            <p className="text-sm text-slate-500">{submission.worker?.email}</p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div>
                            <p className="font-medium">{submission.task?.title}</p>
                            <p className="text-sm text-slate-500 capitalize">{submission.task?.task_type?.replace("_", " ")}</p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Badge
                            className={
                              submission.status === "approved"
                                ? "bg-green-100 text-green-700"
                                : submission.status === "rejected"
                                ? "bg-red-100 text-red-700"
                                : "bg-amber-100 text-amber-700"
                            }
                          >
                            {submission.status}
                          </Badge>
                        </TableCell>
                        <TableCell className="font-medium text-amber-600">
                          {submission.task?.points_reward} pts
                        </TableCell>
                        <TableCell className="text-slate-500">
                          {new Date(submission.submitted_at).toLocaleDateString()}
                        </TableCell>
                        <TableCell>
                          {submission.status === "pending" && (
                            <div className="flex items-center gap-2">
                              {submission.screenshot_data && (
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  title="View Screenshot"
                                  onClick={() => {
                                    const win = window.open();
                                    win.document.write(`<img src="${submission.screenshot_data}" style="max-width:100%"/>`);
                                  }}
                                  data-testid={`view-screenshot-${submission.submission_id}`}
                                >
                                  <Eye className="w-4 h-4" />
                                </Button>
                              )}
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-green-600"
                                onClick={() => handleReviewSubmission(submission.submission_id, "approved")}
                                data-testid={`approve-submission-${submission.submission_id}`}
                              >
                                <Check className="w-4 h-4" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-red-600"
                                onClick={() => handleReviewSubmission(submission.submission_id, "rejected")}
                                data-testid={`reject-submission-${submission.submission_id}`}
                              >
                                <X className="w-4 h-4" />
                              </Button>
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                
                {/* Pagination */}
                {submissionTotalPages > 1 && (
                  <div className="flex items-center justify-between px-4 py-3 border-t">
                    <span className="text-sm text-slate-500">
                      Page {submissionPage} of {submissionTotalPages}
                    </span>
                    <div className="flex items-center gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setSubmissionPage(p => Math.max(1, p - 1))}
                        disabled={submissionPage === 1}
                      >
                        <ChevronLeft className="w-4 h-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setSubmissionPage(p => Math.min(submissionTotalPages, p + 1))}
                        disabled={submissionPage === submissionTotalPages}
                      >
                        <ChevronRight className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Withdrawals Tab */}
          <TabsContent value="withdrawals">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex items-center justify-between">
                  <CardTitle className="font-heading text-xl">Withdrawal Requests</CardTitle>
                  <Button 
                    size="sm" 
                    variant="outline" 
                    onClick={() => handleExport('withdrawals')}
                    data-testid="export-withdrawals-btn"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Export CSV
                  </Button>
                </div>
              </CardHeader>
              <CardContent className="p-0">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>User</TableHead>
                      <TableHead>Amount</TableHead>
                      <TableHead>Fee</TableHead>
                      <TableHead>Net</TableHead>
                      <TableHead>Method</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Requested</TableHead>
                      <TableHead>Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {withdrawals.map((withdrawal) => (
                      <TableRow key={withdrawal.withdrawal_id}>
                        <TableCell>
                          <div>
                            <p className="font-medium">{withdrawal.user?.name}</p>
                            <p className="text-sm text-slate-500">{withdrawal.user?.email}</p>
                          </div>
                        </TableCell>
                        <TableCell className="font-medium">${withdrawal.amount?.toFixed(2)}</TableCell>
                        <TableCell className="text-slate-500">${withdrawal.fee_amount?.toFixed(2)}</TableCell>
                        <TableCell className="font-medium text-green-600">${withdrawal.net_amount?.toFixed(2)}</TableCell>
                        <TableCell>
                          <Badge variant="outline" className="capitalize">{withdrawal.payment_method}</Badge>
                        </TableCell>
                        <TableCell>
                          <Badge
                            className={
                              withdrawal.status === "completed"
                                ? "bg-green-100 text-green-700"
                                : withdrawal.status === "rejected"
                                ? "bg-red-100 text-red-700"
                                : withdrawal.status === "processing"
                                ? "bg-blue-100 text-blue-700"
                                : "bg-amber-100 text-amber-700"
                            }
                          >
                            {withdrawal.status}
                          </Badge>
                        </TableCell>
                        <TableCell className="text-slate-500">
                          {new Date(withdrawal.created_at).toLocaleDateString()}
                        </TableCell>
                        <TableCell>
                          {withdrawal.status === "pending" && (
                            <div className="flex items-center gap-2">
                              <Button
                                variant="ghost"
                                size="sm"
                                className="text-blue-600"
                                onClick={() => handleProcessWithdrawal(withdrawal.withdrawal_id, "processing")}
                                data-testid={`process-withdrawal-${withdrawal.withdrawal_id}`}
                              >
                                Process
                              </Button>
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-red-600"
                                onClick={() => handleProcessWithdrawal(withdrawal.withdrawal_id, "rejected")}
                                data-testid={`reject-withdrawal-${withdrawal.withdrawal_id}`}
                              >
                                <X className="w-4 h-4" />
                              </Button>
                            </div>
                          )}
                          {withdrawal.status === "processing" && (
                            <div className="flex items-center gap-2">
                              {withdrawal.payment_method === "paypal" && (
                                <Button
                                  variant="default"
                                  size="sm"
                                  className="bg-[#0070ba] hover:bg-[#005ea6] text-white"
                                  onClick={() => handleSendPayPalPayout(withdrawal.withdrawal_id)}
                                  data-testid={`paypal-payout-${withdrawal.withdrawal_id}`}
                                >
                                  <DollarSign className="w-4 h-4 mr-1" />
                                  Send PayPal
                                </Button>
                              )}
                              <Button
                                variant="ghost"
                                size="sm"
                                className="text-green-600"
                                onClick={() => handleProcessWithdrawal(withdrawal.withdrawal_id, "completed")}
                                data-testid={`complete-withdrawal-${withdrawal.withdrawal_id}`}
                              >
                                Complete
                              </Button>
                            </div>
                          )}
                          {withdrawal.status === "completed" && withdrawal.payout_details && (
                            <span className="text-xs text-slate-500">
                              {withdrawal.payout_details.simulated ? "Simulated" : withdrawal.payout_details.payout_batch_id?.slice(0, 12) || "Paid"}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Clients & Domains Tab */}
          <TabsContent value="clients">
            <AdminClients />
          </TabsContent>

          {/* Reports Tab */}
          <TabsContent value="reports">
            <AdminReports token={token} users={users} groups={groups} />
          </TabsContent>

          {/* Settings Tab */}
          <TabsContent value="settings">
            <div className="space-y-6">
              {/* Account Security - Change Password */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <CardTitle className="font-heading text-xl flex items-center gap-2">
                    <Lock className="w-5 h-5" />
                    Account Security
                  </CardTitle>
                  <CardDescription>Change your admin password</CardDescription>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="max-w-md space-y-4">
                    <div>
                      <Label htmlFor="currentPassword">Current Password</Label>
                      <Input
                        id="currentPassword"
                        type="password"
                        value={passwordForm.currentPassword}
                        onChange={(e) => setPasswordForm({...passwordForm, currentPassword: e.target.value})}
                        placeholder="Enter current password"
                        className="mt-1"
                        data-testid="current-password-input"
                      />
                    </div>
                    <div>
                      <Label htmlFor="newPassword">New Password</Label>
                      <Input
                        id="newPassword"
                        type="password"
                        value={passwordForm.newPassword}
                        onChange={(e) => setPasswordForm({...passwordForm, newPassword: e.target.value})}
                        placeholder="Enter new password"
                        className="mt-1"
                        data-testid="new-password-input"
                      />
                    </div>
                    <div>
                      <Label htmlFor="confirmPassword">Confirm New Password</Label>
                      <Input
                        id="confirmPassword"
                        type="password"
                        value={passwordForm.confirmPassword}
                        onChange={(e) => setPasswordForm({...passwordForm, confirmPassword: e.target.value})}
                        placeholder="Confirm new password"
                        className="mt-1"
                        data-testid="confirm-password-input"
                      />
                    </div>
                    <div className="text-xs text-slate-500 space-y-1">
                      <p>Password requirements:</p>
                      <ul className="list-disc list-inside">
                        <li className={passwordForm.newPassword.length >= 8 ? "text-green-600" : ""}>At least 8 characters</li>
                        <li className={/[A-Z]/.test(passwordForm.newPassword) ? "text-green-600" : ""}>One uppercase letter</li>
                        <li className={/[a-z]/.test(passwordForm.newPassword) ? "text-green-600" : ""}>One lowercase letter</li>
                        <li className={/[0-9]/.test(passwordForm.newPassword) ? "text-green-600" : ""}>One number</li>
                      </ul>
                    </div>
                    <Button 
                      onClick={handleChangePassword}
                      disabled={changingPassword}
                      className="bg-[#00B894] hover:bg-[#00A085]"
                      data-testid="change-password-btn"
                    >
                      {changingPassword ? (
                        <>
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                          Changing...
                        </>
                      ) : (
                        <>
                          <Lock className="w-4 h-4 mr-2" />
                          Change Password
                        </>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>

              {/* Contact Submissions */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl flex items-center gap-2">
                        <Inbox className="w-5 h-5" />
                        Contact Submissions
                        {contactSubmissions.filter(c => c.status === 'new').length > 0 && (
                          <Badge className="bg-red-500 text-white ml-2">
                            {contactSubmissions.filter(c => c.status === 'new').length} new
                          </Badge>
                        )}
                      </CardTitle>
                      <CardDescription>Messages from the contact form</CardDescription>
                    </div>
                    {contactSubmissions.length > 0 && (
                      <Button 
                        size="sm" 
                        variant="outline" 
                        onClick={() => handleExport('contacts')}
                        data-testid="export-contacts-btn"
                      >
                        <Download className="w-4 h-4 mr-2" />
                        Export CSV
                      </Button>
                    )}
                  </div>
                </CardHeader>
                <CardContent className="p-0">
                  {contactSubmissions.length === 0 ? (
                    <div className="p-8 text-center text-slate-500">
                      <MessageSquare className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                      <p>No contact submissions yet</p>
                    </div>
                  ) : (
                    <div className="divide-y">
                      {contactSubmissions.map((contact) => (
                        <div key={contact.contact_id} className="p-4 hover:bg-slate-50">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <span className="font-medium text-slate-900">{contact.name}</span>
                                <span className="text-sm text-slate-500">({contact.email})</span>
                                <Badge variant="outline" className={
                                  contact.status === 'new' ? 'bg-red-50 text-red-600 border-red-200' :
                                  contact.status === 'read' ? 'bg-blue-50 text-blue-600 border-blue-200' :
                                  contact.status === 'responded' ? 'bg-green-50 text-green-600 border-green-200' :
                                  'bg-slate-100 text-slate-600'
                                }>
                                  {contact.status}
                                </Badge>
                              </div>
                              <p className="font-medium text-slate-800 mb-1">{contact.subject}</p>
                              <p className="text-sm text-slate-600 line-clamp-2">{contact.message}</p>
                              <p className="text-xs text-slate-400 mt-2">
                                {new Date(contact.created_at).toLocaleString()}
                              </p>
                            </div>
                            <div className="flex items-center gap-1">
                              <Select 
                                value={contact.status} 
                                onValueChange={(value) => handleUpdateContactStatus(contact.contact_id, value)}
                              >
                                <SelectTrigger className="w-32 h-8">
                                  <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="new">New</SelectItem>
                                  <SelectItem value="read">Read</SelectItem>
                                  <SelectItem value="responded">Responded</SelectItem>
                                  <SelectItem value="closed">Closed</SelectItem>
                                </SelectContent>
                              </Select>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => window.open(`mailto:${contact.email}?subject=Re: ${contact.subject}`, '_blank')}
                                title="Reply via email"
                              >
                                <Mail className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Email Health Status */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl flex items-center gap-2">
                        <Activity className="w-5 h-5" />
                        Email Health Status
                        {emailHealthStats?.health_status && (
                          <Badge className={
                            emailHealthStats.health_status === 'healthy' ? 'bg-green-100 text-green-700' :
                            emailHealthStats.health_status === 'attention_needed' ? 'bg-amber-100 text-amber-700' :
                            'bg-red-100 text-red-700'
                          }>
                            {emailHealthStats.health_status === 'healthy' ? 'Healthy' :
                             emailHealthStats.health_status === 'attention_needed' ? 'Attention Needed' : 'Critical'}
                          </Badge>
                        )}
                      </CardTitle>
                      <CardDescription>Domain reputation and deliverability overview (last 30 days)</CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="p-6">
                  {emailHealthStats ? (
                    <div className="space-y-6">
                      {/* Summary Stats */}
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="bg-slate-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-slate-600">{emailHealthStats.summary?.total_suppressed || 0}</p>
                          <p className="text-xs text-slate-500">Total Suppressed</p>
                        </div>
                        <div className="bg-red-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-red-600">{emailHealthStats.summary?.bounces_last_period || 0}</p>
                          <p className="text-xs text-red-700">Bounces (30d)</p>
                        </div>
                        <div className="bg-amber-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-amber-600">{emailHealthStats.summary?.complaints_last_period || 0}</p>
                          <p className="text-xs text-amber-700">Complaints (30d)</p>
                        </div>
                        <div className={`rounded-lg p-4 text-center ${
                          emailHealthStats.health_status === 'healthy' ? 'bg-green-50' :
                          emailHealthStats.health_status === 'attention_needed' ? 'bg-amber-50' : 'bg-red-50'
                        }`}>
                          <p className={`text-2xl font-bold ${
                            emailHealthStats.health_status === 'healthy' ? 'text-green-600' :
                            emailHealthStats.health_status === 'attention_needed' ? 'text-amber-600' : 'text-red-600'
                          }`}>
                            {emailHealthStats.health_status === 'healthy' ? '✓' :
                             emailHealthStats.health_status === 'attention_needed' ? '!' : '⚠'}
                          </p>
                          <p className="text-xs text-slate-700">Status</p>
                        </div>
                      </div>

                      {/* Suppression Breakdown */}
                      {emailHealthStats.suppression_breakdown && Object.keys(emailHealthStats.suppression_breakdown).length > 0 && (
                        <div>
                          <h4 className="font-medium text-sm mb-3">Suppression Breakdown</h4>
                          <div className="flex flex-wrap gap-2">
                            {Object.entries(emailHealthStats.suppression_breakdown).map(([reason, count]) => (
                              <Badge key={reason} variant="outline" className={
                                reason === 'spam_complaint' ? 'border-red-300 text-red-700' :
                                reason === 'bounce' ? 'border-amber-300 text-amber-700' :
                                'border-slate-300 text-slate-700'
                              }>
                                {reason.replace('_', ' ')}: {count}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Webhook Info */}
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-medium text-sm text-blue-800 mb-2 flex items-center gap-2">
                          <Globe className="w-4 h-4" />
                          Postmark Webhook URL
                        </h4>
                        <code className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded block overflow-x-auto">
                          {window.location.origin}/api/webhooks/postmark
                        </code>
                        <p className="text-xs text-blue-600 mt-2">
                          Configure this URL in your Postmark dashboard under Webhooks → Bounces and Spam Complaints
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-8 text-slate-500">
                      <Activity className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                      <p>Loading email health data...</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Email Delivery Report */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl flex items-center gap-2">
                        <BarChart3 className="w-5 h-5" />
                        Email Delivery Report
                      </CardTitle>
                      <CardDescription>Last 7 days email delivery statistics</CardDescription>
                    </div>
                    <Button size="sm" variant="outline" onClick={fetchData}>
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Refresh
                    </Button>
                  </div>
                </CardHeader>
                <CardContent className="p-6">
                  {emailDeliveryReport ? (
                    <div className="space-y-6">
                      {/* Summary Cards */}
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="bg-green-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-green-600">{emailDeliveryReport.summary?.total_delivered || 0}</p>
                          <p className="text-xs text-green-700">Delivered</p>
                          <p className="text-xs text-green-600 mt-1">{emailDeliveryReport.summary?.delivery_rate || 0}%</p>
                        </div>
                        <div className="bg-red-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-red-600">{emailDeliveryReport.summary?.total_bounced || 0}</p>
                          <p className="text-xs text-red-700">Bounced</p>
                          <p className="text-xs text-red-600 mt-1">{emailDeliveryReport.summary?.bounce_rate || 0}%</p>
                        </div>
                        <div className="bg-amber-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-amber-600">{emailDeliveryReport.summary?.total_complaints || 0}</p>
                          <p className="text-xs text-amber-700">Complaints</p>
                          <p className="text-xs text-amber-600 mt-1">{emailDeliveryReport.summary?.complaint_rate || 0}%</p>
                        </div>
                        <div className="bg-slate-50 rounded-lg p-4 text-center">
                          <p className="text-2xl font-bold text-slate-600">{emailDeliveryReport.summary?.total_policy_rejections || 0}</p>
                          <p className="text-xs text-slate-700">Policy Rejected</p>
                        </div>
                      </div>

                      {/* Top Bounced Emails */}
                      {emailDeliveryReport.top_bounced_emails?.length > 0 && (
                        <div>
                          <h4 className="font-medium text-sm mb-3 flex items-center gap-2">
                            <AlertTriangle className="w-4 h-4 text-amber-500" />
                            Recent Problem Emails
                          </h4>
                          <div className="space-y-2 max-h-48 overflow-y-auto">
                            {emailDeliveryReport.top_bounced_emails.slice(0, 5).map((item, idx) => (
                              <div key={idx} className="flex items-center justify-between bg-slate-50 rounded-lg p-3">
                                <div>
                                  <p className="text-sm font-medium">{item.email}</p>
                                  <p className="text-xs text-slate-500 truncate max-w-md">{item.reason}</p>
                                </div>
                                <Badge variant="outline" className="text-red-600">{item.count}x</Badge>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-slate-500">
                      <BarChart3 className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                      <p>No delivery data available yet</p>
                      <p className="text-xs mt-1">Data will appear after emails are sent via SparkPost</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Suppression List */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="font-heading text-xl flex items-center gap-2">
                        <ShieldX className="w-5 h-5" />
                        Suppression List
                        {suppressionList.length > 0 && (
                          <Badge className="bg-red-100 text-red-700 ml-2">{suppressionList.length}</Badge>
                        )}
                      </CardTitle>
                      <CardDescription>Emails that won't receive task notifications (bounces, complaints)</CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="p-0">
                  {suppressionList.length === 0 ? (
                    <div className="p-8 text-center text-slate-500">
                      <CheckCircle className="w-12 h-12 mx-auto mb-4 text-green-300" />
                      <p>No suppressed emails</p>
                      <p className="text-xs mt-1">Bounced and complained emails will appear here</p>
                    </div>
                  ) : (
                    <div className="divide-y max-h-64 overflow-y-auto">
                      {suppressionList.map((entry) => (
                        <div key={entry.suppression_id} className="p-4 flex items-center justify-between hover:bg-slate-50">
                          <div>
                            <p className="font-medium text-sm">{entry.email}</p>
                            <div className="flex items-center gap-2 mt-1">
                              <Badge variant="outline" className={
                                entry.reason === 'spam_complaint' ? 'text-red-600 border-red-200' :
                                entry.reason === 'bounce' ? 'text-amber-600 border-amber-200' :
                                'text-slate-600'
                              }>
                                {entry.reason?.replace('_', ' ')}
                              </Badge>
                              <span className="text-xs text-slate-400">
                                {new Date(entry.created_at).toLocaleDateString()}
                              </span>
                            </div>
                            {entry.details && (
                              <p className="text-xs text-slate-500 mt-1 truncate max-w-md">{entry.details}</p>
                            )}
                          </div>
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            className="text-slate-400 hover:text-red-500"
                            onClick={() => handleRemoveFromSuppression(entry.suppression_id)}
                            title="Remove from suppression (use with caution)"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Webhook Configuration */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <CardTitle className="font-heading text-xl flex items-center gap-2">
                    <Link2 className="w-5 h-5" />
                    SparkPost Webhook Configuration
                  </CardTitle>
                  <CardDescription>Configure SparkPost to send delivery events to GigsEasy</CardDescription>
                </CardHeader>
                <CardContent className="p-6">
                  {webhookConfig ? (
                    <div className="space-y-4">
                      <div>
                        <Label className="text-sm text-slate-500">Webhook URL</Label>
                        <div className="flex items-center gap-2 mt-1">
                          <Input 
                            readOnly 
                            value={webhookConfig.sparkpost_webhook_url} 
                            className="font-mono text-sm bg-slate-50"
                          />
                          <Button 
                            size="sm" 
                            variant="outline"
                            onClick={() => {
                              navigator.clipboard.writeText(webhookConfig.sparkpost_webhook_url);
                              toast.success("Webhook URL copied!");
                            }}
                          >
                            <Copy className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                      
                      <div>
                        <Label className="text-sm text-slate-500">Events to Enable</Label>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {webhookConfig.webhook_events_to_enable?.map(event => (
                            <Badge key={event} variant="outline" className="capitalize">
                              {event.replace('_', ' ')}
                            </Badge>
                          ))}
                        </div>
                      </div>
                      
                      <div className="bg-blue-50 rounded-lg p-4 mt-4">
                        <h4 className="font-medium text-sm text-blue-800 mb-2">Setup Instructions</h4>
                        <ol className="text-xs text-blue-700 space-y-1 list-decimal list-inside">
                          {webhookConfig.instructions?.map((step, idx) => (
                            <li key={idx}>{step}</li>
                          ))}
                        </ol>
                      </div>
                      
                      <div className="bg-amber-50 rounded-lg p-3 text-xs text-amber-800">
                        <strong>Note:</strong> {webhookConfig.note}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-8 text-slate-500">
                      <Link2 className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                      <p>Loading webhook configuration...</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Email Templates */}
              <Card className="border-slate-200">
                <CardHeader className="border-b border-slate-100">
                  <CardTitle className="font-heading text-xl flex items-center gap-2">
                    <FileText className="w-5 h-5" />
                    Email Templates
                  </CardTitle>
                  <CardDescription>Manage email templates for task notifications</CardDescription>
                </CardHeader>
                <CardContent className="p-0">
                  <AdminEmailTemplates token={token} />
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Support Tickets Tab */}
          <TabsContent value="support">
            {selectedTicket && ticketDetail ? (
              // Ticket Detail View
              <Card className="border-slate-200" data-testid="ticket-detail-view">
                <CardHeader className="border-b border-slate-100">
                  <div className="flex items-center gap-4">
                    <Button 
                      variant="ghost" 
                      size="icon" 
                      onClick={() => { setSelectedTicket(null); setTicketDetail(null); }}
                      data-testid="back-to-tickets-btn"
                    >
                      <ArrowLeft className="w-5 h-5" />
                    </Button>
                    <div className="flex-1">
                      <CardTitle className="font-heading text-xl">{ticketDetail.ticket?.subject}</CardTitle>
                      <div className="flex items-center gap-2 mt-2">
                        <Badge className={
                          ticketDetail.ticket?.status === "open" ? "bg-blue-100 text-blue-700" :
                          ticketDetail.ticket?.status === "in_progress" ? "bg-amber-100 text-amber-700" :
                          ticketDetail.ticket?.status === "waiting_user" ? "bg-purple-100 text-purple-700" :
                          ticketDetail.ticket?.status === "resolved" ? "bg-green-100 text-green-700" :
                          "bg-slate-100 text-slate-700"
                        }>
                          {ticketDetail.ticket?.status?.replace("_", " ")}
                        </Badge>
                        <Badge className={
                          ticketDetail.ticket?.priority === "urgent" ? "bg-red-100 text-red-700" :
                          ticketDetail.ticket?.priority === "high" ? "bg-orange-100 text-orange-700" :
                          ticketDetail.ticket?.priority === "medium" ? "bg-yellow-100 text-yellow-700" :
                          "bg-slate-100 text-slate-600"
                        }>
                          {ticketDetail.ticket?.priority}
                        </Badge>
                        <Badge variant="outline">{ticketDetail.ticket?.category}</Badge>
                        <span className="text-xs text-slate-500">#{ticketDetail.ticket?.ticket_id?.slice(7, 19)}</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <Select 
                        value={ticketDetail.ticket?.status} 
                        onValueChange={(v) => handleUpdateTicketStatus(selectedTicket, v)}
                      >
                        <SelectTrigger className="w-40" data-testid="ticket-status-select">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="open">Open</SelectItem>
                          <SelectItem value="in_progress">In Progress</SelectItem>
                          <SelectItem value="waiting_user">Waiting on User</SelectItem>
                          <SelectItem value="resolved">Resolved</SelectItem>
                          <SelectItem value="closed">Closed</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="p-6">
                  {/* User Info */}
                  <div className="bg-slate-50 rounded-lg p-4 mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center">
                        <User className="w-5 h-5 text-slate-600" />
                      </div>
                      <div>
                        <p className="font-medium">{ticketDetail.ticket?.user_name}</p>
                        <p className="text-sm text-slate-500">{ticketDetail.ticket?.user_email}</p>
                      </div>
                      <div className="ml-auto text-right text-sm text-slate-500">
                        <p>Created: {new Date(ticketDetail.ticket?.created_at).toLocaleString()}</p>
                        <p>Updated: {new Date(ticketDetail.ticket?.updated_at).toLocaleString()}</p>
                      </div>
                    </div>
                  </div>

                  {/* Messages Thread */}
                  <div className="space-y-4 mb-6 max-h-[400px] overflow-y-auto">
                    {ticketDetail.messages?.map((msg) => (
                      <div
                        key={msg.message_id}
                        className={`flex ${msg.sender_type === "admin" ? "justify-end" : "justify-start"}`}
                      >
                        <div className={`max-w-[80%] ${msg.sender_type === "admin" ? "order-2" : ""}`}>
                          <div className={`rounded-lg p-4 ${
                            msg.sender_type === "admin" 
                              ? "bg-blue-500 text-white" 
                              : "bg-white border border-slate-200"
                          }`}>
                            <div className="flex items-center gap-2 mb-2">
                              {msg.sender_type === "admin" ? (
                                <Shield className="w-4 h-4" />
                              ) : (
                                <User className="w-4 h-4" />
                              )}
                              <span className={`text-sm font-medium ${msg.sender_type === "admin" ? "text-white" : "text-slate-700"}`}>
                                {msg.sender_type === "admin" ? "Support Team" : msg.sender_name}
                              </span>
                            </div>
                            <p className={`text-sm whitespace-pre-wrap ${msg.sender_type === "admin" ? "text-white" : "text-slate-600"}`}>
                              {msg.message}
                            </p>
                          </div>
                          <p className={`text-xs mt-1 ${msg.sender_type === "admin" ? "text-right" : ""} text-slate-400`}>
                            {new Date(msg.created_at).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Reply Input */}
                  {ticketDetail.ticket?.status !== "closed" && (
                    <div className="bg-white rounded-lg border border-slate-200 p-4">
                      <Textarea
                        placeholder="Type your reply..."
                        value={ticketReplyMessage}
                        onChange={(e) => setTicketReplyMessage(e.target.value)}
                        rows={3}
                        className="mb-3"
                        data-testid="admin-reply-input"
                      />
                      <div className="flex justify-end">
                        <Button 
                          onClick={handleSendTicketReply} 
                          disabled={submittingReply || !ticketReplyMessage.trim()}
                          data-testid="admin-send-reply-btn"
                        >
                          {submittingReply ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
                          Send Reply
                        </Button>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            ) : (
              // Tickets List View
              <div className="space-y-6">
                {/* Ticket Stats */}
                {ticketStats && (
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <Card className="border-slate-200">
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm text-slate-500">Open Tickets</p>
                            <p className="text-2xl font-bold text-blue-600">{ticketStats.by_status?.open || 0}</p>
                          </div>
                          <Inbox className="w-8 h-8 text-blue-200" />
                        </div>
                      </CardContent>
                    </Card>
                    <Card className="border-slate-200">
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm text-slate-500">In Progress</p>
                            <p className="text-2xl font-bold text-amber-600">{ticketStats.by_status?.in_progress || 0}</p>
                          </div>
                          <Clock className="w-8 h-8 text-amber-200" />
                        </div>
                      </CardContent>
                    </Card>
                    <Card className="border-slate-200">
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm text-slate-500">Urgent</p>
                            <p className="text-2xl font-bold text-red-600">{ticketStats.by_priority?.urgent || 0}</p>
                          </div>
                          <AlertTriangle className="w-8 h-8 text-red-200" />
                        </div>
                      </CardContent>
                    </Card>
                    <Card className="border-slate-200">
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm text-slate-500">Resolved</p>
                            <p className="text-2xl font-bold text-green-600">{ticketStats.by_status?.resolved || 0}</p>
                          </div>
                          <CheckCircle className="w-8 h-8 text-green-200" />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                )}

                <Card className="border-slate-200">
                  <CardHeader className="border-b border-slate-100">
                    <div className="flex items-center justify-between">
                      <CardTitle className="font-heading text-xl">Support Tickets</CardTitle>
                      <Button size="sm" variant="outline" onClick={fetchSupportTickets} data-testid="refresh-tickets-btn">
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Refresh
                      </Button>
                    </div>
                    
                    {/* Search and Filters */}
                    <div className="flex flex-wrap gap-3 items-center mt-4">
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                        <Input
                          placeholder="Search by subject, user, email..."
                          value={supportTicketSearch}
                          onChange={(e) => { setSupportTicketSearch(e.target.value); setSupportTicketPage(1); }}
                          className="pl-10 w-64"
                          data-testid="ticket-search-input"
                        />
                      </div>
                      <Select 
                        value={supportTicketStatusFilter} 
                        onValueChange={(v) => { setSupportTicketStatusFilter(v); setSupportTicketPage(1); }}
                      >
                        <SelectTrigger className="w-40" data-testid="ticket-status-filter">
                          <SelectValue placeholder="Filter by status" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="all">All Status</SelectItem>
                          <SelectItem value="open">Open</SelectItem>
                          <SelectItem value="in_progress">In Progress</SelectItem>
                          <SelectItem value="waiting_user">Waiting on User</SelectItem>
                          <SelectItem value="resolved">Resolved</SelectItem>
                          <SelectItem value="closed">Closed</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </CardHeader>
                  <CardContent className="p-0">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Subject</TableHead>
                          <TableHead>User</TableHead>
                          <TableHead>Status</TableHead>
                          <TableHead>Priority</TableHead>
                          <TableHead>Category</TableHead>
                          <TableHead>Last Update</TableHead>
                          <TableHead>Actions</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {supportTickets.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={7} className="text-center py-12">
                              <MessageSquare className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                              <p className="text-slate-500">No support tickets found</p>
                            </TableCell>
                          </TableRow>
                        ) : (
                          supportTickets.map((ticket) => (
                            <TableRow key={ticket.ticket_id} className="cursor-pointer hover:bg-slate-50">
                              <TableCell className="font-medium max-w-[200px]">
                                <div className="flex items-center gap-2">
                                  <span className="truncate">{ticket.subject}</span>
                                  {ticket.last_reply_by === "user" && ticket.status !== "closed" && (
                                    <Badge className="bg-blue-100 text-blue-700 text-xs">New</Badge>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell>
                                <div>
                                  <p className="font-medium text-sm">{ticket.user_name}</p>
                                  <p className="text-xs text-slate-500">{ticket.user_email}</p>
                                </div>
                              </TableCell>
                              <TableCell>
                                <Badge className={
                                  ticket.status === "open" ? "bg-blue-100 text-blue-700" :
                                  ticket.status === "in_progress" ? "bg-amber-100 text-amber-700" :
                                  ticket.status === "waiting_user" ? "bg-purple-100 text-purple-700" :
                                  ticket.status === "resolved" ? "bg-green-100 text-green-700" :
                                  "bg-slate-100 text-slate-700"
                                }>
                                  {ticket.status?.replace("_", " ")}
                                </Badge>
                              </TableCell>
                              <TableCell>
                                <Badge className={
                                  ticket.priority === "urgent" ? "bg-red-100 text-red-700" :
                                  ticket.priority === "high" ? "bg-orange-100 text-orange-700" :
                                  ticket.priority === "medium" ? "bg-yellow-100 text-yellow-700" :
                                  "bg-slate-100 text-slate-600"
                                }>
                                  {ticket.priority}
                                </Badge>
                              </TableCell>
                              <TableCell>
                                <Badge variant="outline" className="text-xs">{ticket.category}</Badge>
                              </TableCell>
                              <TableCell className="text-sm text-slate-500">
                                {new Date(ticket.updated_at).toLocaleDateString()}
                              </TableCell>
                              <TableCell>
                                <Button 
                                  variant="ghost" 
                                  size="sm"
                                  onClick={() => handleViewTicket(ticket.ticket_id)}
                                  data-testid={`view-ticket-${ticket.ticket_id}`}
                                >
                                  <Eye className="w-4 h-4 mr-1" />
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                    
                    {/* Pagination */}
                    {supportTicketTotalPages > 1 && (
                      <div className="flex items-center justify-between px-4 py-3 border-t">
                        <span className="text-sm text-slate-500">
                          Page {supportTicketPage} of {supportTicketTotalPages}
                        </span>
                        <div className="flex items-center gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setSupportTicketPage(p => Math.max(1, p - 1))}
                            disabled={supportTicketPage === 1}
                          >
                            <ChevronLeft className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setSupportTicketPage(p => Math.min(supportTicketTotalPages, p + 1))}
                            disabled={supportTicketPage === supportTicketTotalPages}
                          >
                            <ChevronRight className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}
          </TabsContent>

          {/* Audit Logs Tab */}
          <TabsContent value="audit">
            <Card className="border-slate-200">
              <CardHeader className="border-b border-slate-100">
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle className="font-heading text-xl flex items-center gap-2">
                      <History className="w-5 h-5" />
                      Audit Logs
                    </CardTitle>
                    <CardDescription>Track all actions performed on the platform</CardDescription>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={handleExportAuditLogs}
                      data-testid="export-audit-logs-btn"
                    >
                      <Download className="w-4 h-4 mr-2" />
                      Export CSV
                    </Button>
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={fetchAuditLogs}
                      data-testid="refresh-audit-logs-btn"
                    >
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Refresh
                    </Button>
                  </div>
                </div>

                {/* Stats Cards */}
                {auditLogsStats && (
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                    <div className="bg-slate-50 rounded-lg p-3">
                      <p className="text-sm text-slate-500">Total Logs (30d)</p>
                      <p className="text-2xl font-bold text-slate-900">{auditLogsStats.total_logs}</p>
                    </div>
                    <div className="bg-blue-50 rounded-lg p-3">
                      <p className="text-sm text-blue-600">Logins</p>
                      <p className="text-2xl font-bold text-blue-900">{auditLogsStats.by_action?.login || 0}</p>
                    </div>
                    <div className="bg-green-50 rounded-lg p-3">
                      <p className="text-sm text-green-600">Approvals</p>
                      <p className="text-2xl font-bold text-green-900">
                        {(auditLogsStats.by_action?.user_approve || 0) + (auditLogsStats.by_action?.submission_approve || 0)}
                      </p>
                    </div>
                    <div className="bg-purple-50 rounded-lg p-3">
                      <p className="text-sm text-purple-600">Task Actions</p>
                      <p className="text-2xl font-bold text-purple-900">
                        {(auditLogsStats.by_action?.task_create || 0) + (auditLogsStats.by_action?.task_update || 0) + (auditLogsStats.by_action?.task_delete || 0)}
                      </p>
                    </div>
                  </div>
                )}

                {/* Filters */}
                <div className="flex flex-wrap gap-3 mt-4">
                  <div className="relative flex-1 min-w-[200px]">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                    <Input
                      placeholder="Search by user email..."
                      value={auditLogsSearch}
                      onChange={(e) => {
                        setAuditLogsSearch(e.target.value);
                        setAuditLogsPage(1);
                      }}
                      className="pl-9"
                      data-testid="audit-search-input"
                    />
                  </div>
                  <Select value={auditLogsActionFilter} onValueChange={(v) => { setAuditLogsActionFilter(v); setAuditLogsPage(1); }}>
                    <SelectTrigger className="w-[180px]" data-testid="audit-action-filter">
                      <SelectValue placeholder="All Actions" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Actions</SelectItem>
                      {auditActionTypes.map(action => (
                        <SelectItem key={action.value} value={action.value}>
                          {action.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Input
                    type="date"
                    value={auditLogsDateFilter}
                    onChange={(e) => { setAuditLogsDateFilter(e.target.value); setAuditLogsPage(1); }}
                    className="w-[160px]"
                    data-testid="audit-date-filter"
                  />
                  {(auditLogsSearch || auditLogsActionFilter !== "all" || auditLogsDateFilter) && (
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      onClick={() => { setAuditLogsSearch(""); setAuditLogsActionFilter("all"); setAuditLogsDateFilter(""); setAuditLogsPage(1); }}
                    >
                      Clear Filters
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardContent className="p-0">
                {loadingAuditLogs ? (
                  <div className="flex items-center justify-center py-12">
                    <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                    <span className="ml-2 text-slate-500">Loading audit logs...</span>
                  </div>
                ) : auditLogs.length === 0 ? (
                  <div className="text-center py-12 text-slate-500">
                    <ClipboardList className="w-12 h-12 mx-auto mb-4 opacity-50" />
                    <p>No audit logs found</p>
                  </div>
                ) : (
                  <>
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-slate-50">
                          <TableHead>Action</TableHead>
                          <TableHead>User</TableHead>
                          <TableHead>Target</TableHead>
                          <TableHead>Details</TableHead>
                          <TableHead>IP Address</TableHead>
                          <TableHead>Timestamp</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {auditLogs.map((log) => (
                          <TableRow key={log.log_id} className="hover:bg-slate-50">
                            <TableCell>
                              <Badge className={`${getActionBadgeColor(log.action)} font-medium`}>
                                {formatActionLabel(log.action)}
                              </Badge>
                            </TableCell>
                            <TableCell>
                              <div className="flex flex-col">
                                <span className="font-medium text-slate-900">{log.actor_email || "System"}</span>
                                <span className="text-xs text-slate-500">{log.actor_id}</span>
                              </div>
                            </TableCell>
                            <TableCell>
                              {log.target_type && (
                                <div className="flex flex-col">
                                  <span className="text-slate-600 capitalize">{log.target_type}</span>
                                  <span className="text-xs text-slate-400 font-mono">{log.target_id}</span>
                                </div>
                              )}
                            </TableCell>
                            <TableCell>
                              <div className="max-w-[200px] truncate text-sm text-slate-600">
                                {log.details?.email && <span>{log.details.email}</span>}
                                {log.details?.title && <span>{log.details.title}</span>}
                                {log.details?.reason && <span className="text-red-600">{log.details.reason}</span>}
                                {log.details?.points && <span className="text-green-600">+{log.details.points} pts</span>}
                              </div>
                            </TableCell>
                            <TableCell>
                              <span className="text-sm text-slate-500 font-mono">
                                {log.ip_address || "-"}
                              </span>
                            </TableCell>
                            <TableCell>
                              <div className="flex flex-col">
                                <span className="text-sm text-slate-600">
                                  {new Date(log.created_at).toLocaleDateString()}
                                </span>
                                <span className="text-xs text-slate-400">
                                  {new Date(log.created_at).toLocaleTimeString()}
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>

                    {/* Pagination */}
                    <div className="flex items-center justify-between px-6 py-4 border-t border-slate-100">
                      <p className="text-sm text-slate-500">
                        Showing {(auditLogsPage - 1) * 20 + 1} - {Math.min(auditLogsPage * 20, auditLogsTotal)} of {auditLogsTotal} logs
                      </p>
                      <div className="flex items-center gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => setAuditLogsPage(p => Math.max(1, p - 1))}
                          disabled={auditLogsPage === 1}
                        >
                          <ChevronLeft className="w-4 h-4" />
                        </Button>
                        <span className="text-sm text-slate-600">
                          Page {auditLogsPage} of {auditLogsTotalPages}
                        </span>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => setAuditLogsPage(p => Math.min(auditLogsTotalPages, p + 1))}
                          disabled={auditLogsPage >= auditLogsTotalPages}
                        >
                          <ChevronRight className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>

        {/* Fraud Details Dialog */}
        <FraudDetailsDialog
          open={showFraudDialog}
          onOpenChange={setShowFraudDialog}
          selectedUserFraud={selectedUserFraud}
          getRiskLevelBadge={getRiskLevelBadge}
          onRecheckFraud={handleRecheckFraud}
          onClearFraudFlag={handleClearFraudFlag}
          onSuspendUser={(userId) => handleUpdateUserStatus(userId, "suspended")}
        />
      </main>
    </div>
  );
}
